import type { Tour } from './tours';

export interface TourDetail extends Tour {
  longDescription: string;
  itinerary: string[];
  included: string[];
  notIncluded: string[];
  bringItems: string[];
  meetingPoint: string;
  startTime: string;
  maxGroupSize: string;
  cancellation: string;
  privacyPolicy?: string;
  importantNotes?: string[];
  gallery: string[];
  relatedTourIds: string[];
}

export const tourDetails: TourDetail[] = [
  {
    id: '2',
    slug: 'Passeio-em-aquamarina-ll',
    title: 'Roteiro sul a Bordo da Escuna Aquamarina II - Paraty, RJ',
    subtitle: 'Escuna Aquamarina II 100% nova – Um Dia de Encantos pelas Águas de Paraty',
    description: 'Explore as deslumbrantes praias de Paraty a bordo da nova escuna Aquamarina II, em um passeio inesquecível repleto de aventura e conforto!',
    longDescription: `Embarque na Escuna Aquamarina II, uma embarcação 100% nova, equipada com infraestrutura moderna e tudo que você precisa para viver um dia inesquecível nas águas de Paraty.

O passeio percorre o roteiro sul, com 4 paradas paradisíacas em praias e ilhas de acesso somente por mar. A bordo você encontra o maior escorregador triplo do Cais de Paraty, Wi-Fi via Starlink, coração e balanço instagramáveis, além de bote de apoio para facilitar o desembarque nas praias.

A escuna conta com banheiros masculino e feminino, som ambiente, bar e restaurante a bordo (pago à parte). Ideal para famílias, casais e grupos de amigos. Crianças são bem-vindas, com coletes salva-vidas disponíveis a bordo.

Recomenda-se chegar 30 minutos antes do embarque para o check-in.`,
    price: 115,
    priceUnit: 'Adulto',
    originalPrice: 150,
    duration: 'aprox. 5 horas',
    difficulty: 'Fácil',
    tags: ['Fácil', 'Aventura', 'Com guia', 'De barco', 'Dia inteiro', 'Pet-friendly'],
    imageUrl: 'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/55e971c5-66d3-4481-cd46-77b181f81500/w=900',
    nextDate: '25/05/2026',
    status: 'Vagas Limitadas',
    imagesCount: 21,
    itinerary: [
      'Saída às 11h do Cais de Turismo de Paraty – chegue 30 min antes',
      'Parada na Ilha dos Cocos – snorkel em aquário natural com peixes coloridos',
      'Parada na Praia da Lula – cenário paradisíaco e águas calmas',
      'Parada na Lagoa Azul – piscina natural de cor azul-turquesa única',
      'Parada na Praia da Conceição – faixa de areia e mergulho livre',
      'Retorno ao Cais de Turismo de Paraty por volta das 16h30',
    ],
    included: [
      'Passeio de 5 horas a bordo da Escuna Aquamarina II',
      'Paradas nas melhores praias e ilhas de Paraty',
      'Bote de apoio para desembarque nas praias',
      'Flutuadores (espaguetes) para nado livre',
      'Escorregador triplo – o maior do Cais de Paraty',
      'Wi-Fi Starlink a bordo',
      'Som ambiente',
      'Banheiros masculino e feminino',
      'Colete salva-vidas disponível para crianças',
    ],
    notIncluded: [
      'Bebidas e alimentos (adquiridos no bar/restaurante a bordo, pago à parte)',
      'Equipamentos de mergulho',
      'Transfer de hotel',
    ],
    bringItems: [
      'Protetor solar (obrigatório)',
      'Roupa de banho',
      'Toalha',
      'Chapéu ou boné',
      'Óculos de sol',
      'Dinheiro para consumo no bar/restaurante a bordo',
      'Câmera ou celular em capa à prova d\'água',
    ],
    meetingPoint: 'Cais de Turismo de Paraty – procure a equipe com camiseta Aquamarina II. Chegue 30 minutos antes do embarque.',
    startTime: '11:00',
    maxGroupSize: 'Escuna coletiva',
    cancellation: 'Cancelamento com 7 dias ou mais de antecedência: reembolso integral. Entre 7 dias e 48 horas antes do passeio: poderá haver retenção de até 20% do valor. Com menos de 48 horas ou não comparecimento (no-show): não há reembolso. Se a empresa cancelar por segurança, condições climáticas ou motivos operacionais, você pode remarcar o passeio ou receber reembolso integral. Troca de data sem custo até 24 horas antes do passeio.',
    privacyPolicy: 'PROIBIDO EMBARQUE COM BEBIDAS OU ALIMENTOS. Somente serão autorizados mediante prévia coordenação com o responsável. A programação e o roteiro poderão sofrer alterações em razão das condições climáticas e marítimas, incluindo vento, condições do mar e outros fatores que possam comprometer a segurança da operação. Durante a travessia dos passageiros da embarcação até a praia, realizada por meio de bote de apoio, a empresa não se responsabiliza por pertences pessoais que sejam molhados, danificados, extraviados ou perdidos. A partir do momento em que os passageiros deixam a embarcação, a responsabilidade pela guarda e conservação de seus pertences pessoais passa a ser exclusivamente dos próprios clientes. Aplicam-se também os termos e condições gerais disponíveis no site.',
    importantNotes: [
      'Chegar 30 minutos antes do embarque para check-in',
      'Em dias de mar agitado, há bancos internos para maior conforto',
      'Crianças bem-vindas com colete salva-vidas disponível a bordo',
      'Bar e restaurante disponíveis a bordo (pago à parte)',
    ],
    gallery: [
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/55e971c5-66d3-4481-cd46-77b181f81500/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/765c03fc-5c17-41a7-eaf9-a88d3ddffd00/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/f85998c3-7c0d-4f95-8d13-e53cc56a7100/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/c185b958-8d47-4924-f440-2c754a99e400/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/5ee380ea-536a-491f-0de8-3e4a45f1f800/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/d7eae037-7c3e-4d87-6ae3-2cdc3ddc9f00/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/05038d12-e9e5-40af-b58e-74029b904e00/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/4383832f-9a13-4933-3fce-c3f0d087a200/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/86abfafc-8c41-48da-aff3-4871ee120a00/w=900',
    ],
    relatedTourIds: ['experiencia-privativa-em-paraty-a-bordo-de-uma-escuna-de-luxo', 'saco-de-mamangua-lancha-rapida'],
    flashDeal: { originalPrice: 130, dealPrice: 110, postOfferPrice: 115 },
  },
  {
    id: '3',
    slug: 'jeep-mata-atlantica',
    title: 'Explore Paraty de Jeep em uma Aventura pela Mata Atlântica',
    subtitle: 'Cachoeiras, Alambique, Casa da Farinha, Poço do Tarzan e Estrada Real',
    description: 'Explore Paraty em um emocionante passeio de jeep 4x4 — Cachoeiras, alambique, casa da farinha, queijaria, Poço do Tarzan, Estrada Real & Sabores de Paraty.',
    longDescription: `Paraty nasceu do Caminho do Ouro e da Estrada Real: a rota histórica por onde o ouro descia da serra rumo ao mar. Neste passeio, você sente essa herança de perto — entre cachoeiras de águas verdes, tradições caiçaras e sabores artesanais.

No trajeto, fazemos uma parada fotográfica no Engenho da Cachaça, marco do início do Caminho do Ouro na região, para você registrar o cenário e ouvir curiosidades que dão vida à história antes de seguir para as quedas d'água.

O passeio é feito em Jeep Toyota Bandeirante 4x4, identificado com o logotipo da Paraty Sirena Tours. Inclui guia local especializado que acompanha o grupo em todas as paradas. Serviço de busca disponível em pousadas e hotéis da região central de Paraty (raio de 3km da agência).`,
    price: 130,
    priceUnit: 'Adulto',
    originalPrice: 155,
    duration: 'aprox. 6 horas',
    difficulty: 'Fácil',
    tags: ['Fácil', 'Aventura', 'Natureza'],
    imageUrl: 'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/488d8c1d-de54-44ca-dc3b-e4c649fb2a00/w=900',
    nextDate: '24/05/2026',
    status: 'Vagas Limitadas',
    imagesCount: 15,
    itinerary: [
      'Pick-up entre 10h00 e 11h00 na sua hospedagem ou ponto combinado (região central de Paraty)',
      '1ª parada: Alambique Paratiana – degustação de cachaças artesanais (opcional, 18+)',
      '2ª parada: Cachoeira Pedra Branca – banho refrescante em meio à Mata Atlântica',
      '3ª parada: Poço da Usina (antiga Uncia) – poço de águas cristalinas para relaxar e nadar',
      '4ª parada: Restaurante Poço do Tarzan – almoço típico ao lado do rio (não incluso)',
      '5ª parada: Pedra de Surf & Poço do Tarzan (1h40) – escorregador natural, nado livre e salto de até 4 metros',
      '6ª parada: Alambique Engenho D\'Ouro – degustação de cachaças e licores + história do Caminho do Ouro',
      '7ª parada: Casa de Farinha – processo artesanal da farinha de mandioca e cultura caiçara',
      '8ª parada (opcional): Queijaria Artesanal Santa Lola – queijos, doces e geleias da serra',
      'Retorno ao final da tarde',
    ],
    included: [
      'Transporte em Jeep Toyota Bandeirante 4x4 com motorista-guia credenciado',
      'Pick-up e drop-off na região central de Paraty (raio de 3km da agência)',
      'Orientações de segurança em todas as paradas',
      'Degustação de cachaças locais',
      'Guia local especializado durante todo o passeio',
    ],
    notIncluded: [
      'Almoço e bebidas',
      'Degustações e compras no alambique e queijaria',
      'Despesas pessoais, fotos extras e seguros opcionais',
    ],
    bringItems: [
      'Roupa de banho por baixo',
      'Toalha',
      'Protetor solar',
      'Repelente',
      'Sapatilha aquática ou tênis',
      'Chinelo',
      'Água',
      'Troca de roupa',
      'Capa estanque para o celular',
    ],
    meetingPoint: 'Agência Paraty Sirena Tours – Av. Roberto Silveira, 578, Paraty, RJ. Serviço de busca gratuito num raio de 3km da agência.',
    startTime: '10:00 – 11:00',
    maxGroupSize: '8 pessoas por Jeep',
    cancellation: 'Em caso de mau tempo que inviabilize o passeio: reagendamento sem custo ou crédito. Cancelamentos por iniciativa do cliente: até 24h antes, reembolso integral. Após esse prazo ou no-show, cobrança de 100%.',
    privacyPolicy: 'Atividade indicada para público em geral com condicionamento leve a moderado. Crianças somente acompanhadas por responsável. Não recomendado para gestantes em estágio avançado ou pessoas em recuperação de cirurgias recentes. O roteiro pode ser alterado por motivos climáticos, maré ou segurança. Proibido coletar plantas, alimentar animais ou deixar lixo. Consumo de álcool apenas para maiores de 18 anos com documento.',
    importantNotes: [
      'Ordem das paradas pode mudar conforme clima e volume d\'água',
      'Degustações e almoço não estão inclusos no valor',
      'Use calçado com boa aderência (tênis/sapatilha aquática) nas cachoeiras',
      'Crianças devem estar sempre acompanhadas por um responsável',
      'Horário de pick-up confirmado por WhatsApp no dia do passeio',
      'Não recomendado para gestantes avançadas ou pós-cirurgia recente',
    ],
    gallery: [
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/488d8c1d-de54-44ca-dc3b-e4c649fb2a00/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/004ac490-e803-413b-6aab-62dfbe6f7e00/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/1a6684ac-1a37-4088-311f-5304c41eda00/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/b5011e61-9cac-41bc-71ab-9fd431283b00/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/32e53128-7764-42f2-ab6d-58aafe10a500/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/7c88b84c-6a54-41a6-c58a-ce48164d7100/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/4873e87c-e7b9-4490-5d0d-414ed63f6100/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/759e0f40-2e79-46c8-004f-c51e5db95e00/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/adb31466-31ee-491b-8c46-033c12fc8a00/w=900',
    ],
    relatedTourIds: ['jeep-mata-atlantica-15823', 'experiencia-privativa-nascer-do-sol-na-pedra-da-marcela'],
    flashDeal: { originalPrice: 155, dealPrice: 130, postOfferPrice: 130 },
  },
  {
    id: '4',
    slug: 'jeep-mata-atlantica-15823',
    title: 'Descubra as Praias Caiçaras de Trindade-RJ',
    subtitle: 'O melhor de Trindade em um dia!',
    description: 'Explore Paraty em um emocionante passeio para Trindade, com degustações de queijos, aventuras em cachoeiras e praias paradisíacas.',
    longDescription: `Prepare-se para uma aventura incrível em meio à Mata Atlântica e às praias paradisíacas de Trindade! Visitaremos 3 praias e 1 piscina natural, com uma experiência única combinando natureza, trilhas e mar cristalino.

Trindade é um vilarejo de pescadores a apenas 30km de Paraty, famoso por suas praias caiçaras de água transparente. O passeio tem duração de aproximadamente 6 horas, com saída entre 10h30 e 11h.

O transporte é feito alternando entre van e jeeps, garantindo conforto e segurança durante todo o percurso.`,
    price: 170,
    priceUnit: 'ADULTO',
    originalPrice: 200,
    duration: 'aprox. 6 horas',
    difficulty: 'Fácil',
    tags: ['Fácil', 'Adrenalina', 'Autoguiado', 'Aventura', 'Cultural', 'De barco', 'Histórico'],
    imageUrl: 'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/c714424a-0aa8-4049-9095-0c8281e5c200/w=900',
    nextDate: '24/05/2026',
    status: 'Vagas Limitadas',
    imagesCount: 2,
    itinerary: [
      'Saída de Paraty entre 10h30 e 11h00 em van ou jeep',
      'Praia do Meio – enseada de águas calmas e cristalinas entre a Mata Atlântica, perfeita para banho e fotos',
      'Praia dos Ranchos – parada de 1 hora para almoço (restaurante não incluso)',
      'Praia do Cachadaço – praia paradisíaca com vista deslumbrante',
      'Piscina Natural do Cachadaço – aquário natural cercado por pedras gigantes; acesso por trilha média de 45 min ou barquinho (R$ 25,00 ida + R$ 25,00 volta por pessoa, não incluso)',
      'Queijaria – parada final com degustação de queijos artesanais',
      'Retorno a Paraty (aproximadamente 6 horas de passeio no total)',
    ],
    included: [
      'Transporte (alternando van e jeeps)',
      'Guia local experiente',
      'Paradas para banho em praias e cachoeiras',
      'Tempo livre para explorar Trindade',
    ],
    notIncluded: [
      'Almoço e bebidas',
      'Travessia de barco para Piscina Natural (R$ 25,00 ida + R$ 25,00 volta)',
      'Máscara e snorkel (aluguel opcional)',
    ],
    bringItems: [
      'Roupa de banho',
      'Tênis para trilha leve',
      'Protetor solar',
      'Toalha',
      'Água',
      'Dinheiro para almoço e opcionais',
    ],
    meetingPoint: 'Agência Paraty Sirena Tours – Av. Roberto Silveira, 578 ou local combinado pelo vendedor.',
    startTime: '10:30 – 11:00',
    maxGroupSize: '12 pessoas',
    cancellation: 'Cancelamento grátis até 24h antes. Reembolso integral até 24h antes do passeio.',
    privacyPolicy: 'Passeio adequado para todas as idades. Menores devem estar acompanhados por responsável. Roteiro sujeito a alterações por condições climáticas.',
    importantNotes: [
      'Saída entre 10h30 e 11h00 – confirmar horário exato pelo WhatsApp',
      'Traversia de barco até Piscina Natural não está inclusa (R$ 25 ida + R$ 25 volta)',
      'Almoço não incluso – restaurante na Praia dos Ranchos (~R$ 60-80)',
      'Trilha de acesso à Piscina Natural tem duração de 45 minutos',
    ],
    gallery: [
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/c714424a-0aa8-4049-9095-0c8281e5c200/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/70a7ec36-db00-4534-76ea-60804b966600/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/c714424a-0aa8-4049-9095-0c8281e5c200/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/70a7ec36-db00-4534-76ea-60804b966600/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/c714424a-0aa8-4049-9095-0c8281e5c200/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/70a7ec36-db00-4534-76ea-60804b966600/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/c714424a-0aa8-4049-9095-0c8281e5c200/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/70a7ec36-db00-4534-76ea-60804b966600/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/c714424a-0aa8-4049-9095-0c8281e5c200/w=900',
    ],
    relatedTourIds: ['jeep-mata-atlantica', 'experiencia-privativa-nascer-do-sol-na-pedra-da-marcela'],
    flashDeal: { originalPrice: 190, dealPrice: 155, postOfferPrice: 160 },
  },
  {
    id: '5',
    slug: 'saco-de-mamangua-lancha-rapida',
    title: 'Passeio de Lancha pelo Saco do Mamanguá',
    subtitle: 'O único fiorde tropical do Brasil – Uma aventura cinematográfica!',
    description: 'Explore o deslumbrante fiorde tropical do Brasil em um emocionante passeio de lancha saindo de Paraty, com paradas em ilhas e praias de acesso exclusivo por mar.',
    longDescription: `O Saco do Mamanguá é o único fiorde tropical do Brasil e um dos cenários mais cinematográficos de toda a Costa Verde. Este passeio de lancha rápida leva você para explorar esse paraíso de águas calmas, cercado por montanhas cobertas de Mata Atlântica.

A lancha é 100% nova e segura, com máscaras de mergulho, coletes salva-vidas e cooler com gelo disponíveis a bordo. Saída do Cais de Turismo de Paraty às 10h30 — chegue 15 minutos antes.

Duração total: 6 horas. Máximo de 15 passageiros por saída. O roteiro pode ser alterado conforme condições do tempo e mar. ATENÇÃO: não é permitido levar seu próprio cooler a bordo.`,
    price: 250,
    priceUnit: 'pessoa',
    originalPrice: 300,
    duration: 'aprox. 6 horas',
    difficulty: 'Intermediário',
    tags: ['Intermediário', 'A pé', 'Adrenalina', 'Ambiente familiar', 'Aventura', 'Com guia', 'De barco', 'Dia inteiro', 'Fast-track', 'Natureza'],
    imageUrl: 'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/2f279564-6d0a-48a3-22c9-037d7309ec00/w=900',
    nextDate: '25/05/2026',
    status: 'Vagas Limitadas',
    imagesCount: 24,
    itinerary: [
      'Saída às 10h30 do Cais de Turismo, Centro Histórico de Paraty (chegar 15 min antes)',
      'Ilha dos Cocos – banho em águas cristalinas e snorkel',
      'Pico do Pão de Açúcar (opcional) – trilha com vista incrível do fiorde tropical',
      'Praia do Engenho – parada com cachoeira próxima',
      'Praia do Cruzeiro – vila caiçara + almoço opcional (não incluso)',
      'Saco da Velha – praia preservada e tranquila',
      'Ilha do Mantimento – parada de 10 minutos (local da filmagem de Crepúsculo/castelo)',
      'Retorno ao Cais de Turismo de Paraty',
    ],
    included: [
      'Passeio de lancha pelo Saco do Mamanguá',
      'Máscaras de mergulho disponíveis a bordo',
      'Colete salva-vidas para todos os passageiros',
      'Cooler com gelo (leve suas bebidas e lanches)',
      'Som ambiente a bordo',
      'Lancha nova, 100% segura',
    ],
    notIncluded: [
      'Refeições e bebidas',
      'Almoço na Praia do Cruzeiro (pago no local)',
      'Trilha até o Pico do Pão de Açúcar é opcional',
    ],
    bringItems: [
      'Protetor solar resistente à água',
      'Boné/chapéu + óculos escuros com cordinha',
      'Roupa de banho + roupa leve extra seca',
      'Toalha de secagem rápida',
      'Chinelo ou sandália (sem calçado fechado)',
      'Garrafinha de água reutilizável',
      'Celular com capa à prova d\'água ou bolsa estanque',
      'Repelente (opcional)',
      'Quebra-vento ou capa de chuva (se mar agitado)',
    ],
    meetingPoint: 'Cais de Turismo, Centro Histórico de Paraty. Entrada do Cais de turismo. O guia entrará em contato.',
    startTime: '10:30',
    maxGroupSize: '15 passageiros',
    cancellation: 'Você tem direito ao arrependimento e poderá cancelar em até 7 dias após a compra com reembolso de 100%, desde que seja respeitado o prazo de 48 horas antes da data e horário agendado.',
    privacyPolicy: 'Roteiro sujeito a alterações por condições climáticas ou de mar. Experiência tem previsão de no mínimo 15 participantes — caso não seja atingido, reembolso integral automático. Aplicam-se os termos e condições gerais do site.',
    importantNotes: [
      'NÃO é permitido levar seu próprio cooler a bordo',
      'Evite roupas largas (vento forte durante a navegação)',
      'Mínimo de 15 participantes para realização do passeio',
      'Paradas de 30-40 min por local (Ilha do Mantimento: 10 min)',
    ],
    gallery: [
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/2f279564-6d0a-48a3-22c9-037d7309ec00/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/f04a9236-d659-4508-e1e2-632a21ac6300/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/3d8cb6b7-1061-433e-92ba-2f4b667b6d00/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/a4413ded-7d22-4779-359e-8904483d0100/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/6835bf4f-1c94-41e7-0b69-69cac1cf3a00/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/cdaab9fe-9048-4ecd-62d8-805938c2a400/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/42a10003-70bb-42fb-a7b4-6b8db345d100/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/fbdfb351-f405-4eb7-d8ef-03bf3e807300/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/6267c82e-06b1-4cff-49cf-ba8e3353cc00/w=900',
    ],
    relatedTourIds: ['passeio-de-lancha-privativa-na-baia-de-paraty-20262', 'lancha-privativa-em-paraty-calobe', 'passeio-de-lancha-privativa-na-baia-de-paraty-lancha-babi-20263'],
    flashDeal: { originalPrice: 280, dealPrice: 230, postOfferPrice: 250 },
  },
  {
    id: '6',
    slug: 'mergulho',
    title: 'Mergulho em Paraty: Aventura Subaquática Inesquecível',
    subtitle: 'Para iniciantes e mergulhadores experientes',
    description: 'Explore as maravilhas subaquáticas de Paraty com um mergulho inesquecível em águas cristalinas, cercado por uma rica biodiversidade marinha!',
    longDescription: `Descubra o mundo subaquático da Costa Verde com um mergulho guiado por instrutores credenciados. As águas de Paraty abrigam peixes tropicais coloridos, corais, tartarugas e uma biodiversidade marinha impressionante.

A experiência tem duração de 4 a 5 horas e é adequada para iniciantes e mergulhadores experientes. O grupo sai de barco para o ponto de melhor visibilidade do dia, acompanhado de instrutores com pequenos grupos para máxima segurança.

Todo o equipamento está incluso: cilindro, regulador, BCD, máscara e lastro. Informe ao instrutor qualquer condição médica antes da imersão. Atividade sujeita a condições do mar.`,
    price: 490,
    priceUnit: 'pessoa',
    originalPrice: 490,
    duration: 'aprox. 4–5 horas',
    difficulty: 'Intermediário',
    tags: ['Intermediário'],
    imageUrl: 'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/322496a5-351d-4f61-341b-c92a02c98200/w=900',
    imagesCount: 8,
    itinerary: [
      'Encontro no Cais de Paraty para check-in e equipagem',
      'Briefing de segurança e técnica de mergulho',
      'Saída de barco para o ponto de melhor visibilidade do dia',
      'Batismo guiado ou mergulho autônomo (1 instrutor para pequenos grupos)',
      'Tempo livre para fotos na superfície',
      'Retorno ao cais com certificado de participação',
    ],
    included: [
      'Equipamentos de mergulho completos (cilindro, regulador, BCD, máscara, lastro)',
      'Instrutores credenciados',
      'Embarcação de apoio',
    ],
    notIncluded: [
      'Refeições e bebidas',
      'Fotos profissionais subaquáticas',
      'Traslados terrestres',
    ],
    bringItems: [
      'Roupa de banho',
      'Toalha',
      'Protetor solar',
      'Água',
      'Documento com foto',
      'Agasalho leve ou corta-vento para o retorno',
    ],
    meetingPoint: 'Cais de Paraty, Centro Histórico.',
    startTime: 'Consultar disponibilidade',
    maxGroupSize: '6 pessoas por instrutor',
    cancellation: 'Cancelamento grátis até 48h antes. Pode remarcar em caso de condições adversas do mar.',
    privacyPolicy: 'Informe ao instrutor qualquer condição médica antes do mergulho. Atividade sujeita a condições do mar. Aplicam-se os termos e condições gerais do site.',
    importantNotes: [
      'Informar condições médicas antes do mergulho',
      'Atividade sujeita a condições do mar',
      'Não comer muito antes da atividade',
    ],
    gallery: [
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/322496a5-351d-4f61-341b-c92a02c98200/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/dffe844a-7bbb-4255-643d-d06ac4ad7b00/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/31ab7113-fac0-4dc8-3672-3f7a2afbb800/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/2d664ae3-abb6-4d5d-323d-8241fbdd8700/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/e0c2858c-0965-45c6-9a3b-3b93ef386200/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/4a2df13b-3ba6-4311-1ac2-f3beb12f3800/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/6c86c639-642b-4417-35e9-2b280950c500/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/0a375ec1-a7a6-4ce5-7c00-ffa9350c6700/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/562d492c-9a21-4905-009f-6516b3457600/w=900',
    ],
    relatedTourIds: ['Passeio-em-aquamarina-ll', 'saco-de-mamangua-lancha-rapida'],
  },
  {
    id: '7',
    slug: 'experiencia-privativa-nascer-do-sol-na-pedra-da-marcela',
    title: 'Nascer do Sol na Pedra da Marcela, Paraty: Passeio Privativo',
    subtitle: 'Máximo 4 pessoas – Experiência exclusiva e inesquecível',
    description: 'Desperte com a natureza! Passeio privativo exclusivo para ver o nascer do sol na Pedra da Marcela, com trilha guiada pela Mata Atlântica e transporte incluso.',
    longDescription: `A Pedra da Marcela é um dos pontos mais bonitos e pouco explorados de Paraty. Este passeio privativo leva você para contemplar o nascer do sol em um mirante panorâmico de tirar o fôlego, com vista para toda a Baía de Paraty e as montanhas da Serra do Mar.

O passeio começa bem antes do amanhecer, com pick-up no seu hotel ou pousada em veículo privado climatizado (SUV ou jipe). A caminhada de aproximadamente 1 hora pela Mata Atlântica preservada é recompensada com um espetáculo natural inesquecível: o sol nascendo sobre o mar de Paraty em tons alaranjados e dourados.

Retorno previsto para Paraty por volta das 9h30 da manhã.

ATENÇÃO: Passeio para grupos de no máximo 4 pessoas. Acima do máximo, sujeito a consulta e disponibilidade.`,
    price: 600,
    priceUnit: 'Grupo',
    originalPrice: 750,
    duration: 'aprox. 6 horas',
    difficulty: 'Intermediário',
    tags: ['Intermediário', 'A partir de 13 anos', 'Aventura', 'Com guia', 'Esportes', 'Natureza', 'Para adultos'],
    imageUrl: 'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/83cebe36-ef1f-4a3b-e01b-e1340522f700/w=900',
    nextDate: '25/05/2026',
    status: 'Vagas Limitadas',
    imagesCount: 4,
    itinerary: [
      'Pick-up no hotel ou pousada em Paraty (bem antes do amanhecer)',
      '1h de trajeto em veículo privado climatizado (SUV ou jipe) por estradas secundárias e off-road',
      'Caminhada de ~1h pela Mata Atlântica preservada até o mirante',
      'Contemplação do nascer do sol na Pedra da Marcela – vista panorâmica do mar, montanhas e mata',
      'Tempo livre no mirante para fotos com a luz dourada da manhã',
      'Caminhada de descida de ~1h',
      'Retorno de veículo para Paraty (~1h) – chegada por volta das 9h30',
    ],
    included: [
      'Passeio 100% privativo para seu grupo (máx. 4 pessoas)',
      'Transporte privado (SUV ou jipe) com ar-condicionado',
      'Guia local bilíngue (português/inglês/espanhol)',
      'Caminhada guiada até a Pedra da Marcela',
      'Pick-up e drop-off no hotel ou pousada em Paraty',
    ],
    notIncluded: [
      'Refeições (trazer lanche leve, se desejar)',
      'Despesas pessoais',
      'Fotógrafo profissional (opcional)',
    ],
    bringItems: [
      'Tênis de trilha ou bota leve (obrigatório)',
      'Jaqueta leve ou casaco (pode estar frio no topo)',
      'Protetor solar, óculos de sol, chapéu/boné',
      'Água (mínimo 1 litro)',
      'Câmera ou celular com bateria carregada',
      'Lanche leve (barra de cereal, frutas secas)',
      'Remédios pessoais, se necessário',
      'Mochila leve',
    ],
    meetingPoint: 'O guia buscará você no hotel ou pousada em Paraty e também deixará de volta ao final.',
    startTime: 'Antes do amanhecer (horário confirmado na reserva)',
    maxGroupSize: 'Máximo 4 pessoas',
    cancellation: 'Cancelamento grátis até 48h antes. Reembolso integral em caso de mau tempo que impeça a realização do passeio.',
    privacyPolicy: 'Passeio a partir de 13 anos. Não recomendado para pessoas com mobilidade reduzida, vertigem ou pós-cirurgia recente. A trilha tem terreno natural com possíveis subidas moderadas — aptidão física média é recomendável. Passeio sujeito a condições climáticas.',
    importantNotes: [
      'Saída bem cedo – prepare-se para acordar de madrugada',
      'Máximo 4 pessoas por passeio',
      'Tênis de trilha é OBRIGATÓRIO',
      'Acima de 4 pessoas, sujeito a consulta e disponibilidade',
      'Roteiro sujeito a condições climáticas',
    ],
    gallery: [
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/83cebe36-ef1f-4a3b-e01b-e1340522f700/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/83dfc846-41f4-469c-fcdc-57699f65ff00/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/c6631efa-9cd5-48fc-f027-4dca0c42dd00/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/6e9d0354-fa49-42ae-a3f5-1951bbd8a900/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/83cebe36-ef1f-4a3b-e01b-e1340522f700/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/83dfc846-41f4-469c-fcdc-57699f65ff00/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/c6631efa-9cd5-48fc-f027-4dca0c42dd00/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/6e9d0354-fa49-42ae-a3f5-1951bbd8a900/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/83cebe36-ef1f-4a3b-e01b-e1340522f700/w=900',
    ],
    relatedTourIds: ['jeep-mata-atlantica', 'jeep-mata-atlantica-15823'],
  },
  {
    id: '8',
    slug: 'passeio-de-lancha-privativa-na-baia-de-paraty-20262',
    title: 'Passeio de Lancha Privativa na Baía de Paraty – LANCHA BABI',
    subtitle: 'Privativo – até 11 pessoas',
    description: 'Passeio privativo de lancha por 5 horas na Baía de Paraty, com paradas para banho e snorkel em águas cristalinas. Roteiro flexível — você escolhe no embarque!',
    longDescription: `A Lancha Babi é uma embarcação privativa com capacidade para até 11 pessoas, perfeita para grupos que buscam exclusividade e flexibilidade na Baía de Paraty.

O passeio tem duração de 5 horas e inclui cooler com gelo, máscaras de mergulho e coletes salva-vidas. O roteiro é flexível e você escolhe no embarque um dos percursos disponíveis.

Roteiros disponíveis:

**1) Clássico Baía de Paraty** (TOP para primeira vez): Ilha dos Cocos (snorkel – aquário natural), Lagoa Azul (piscina azul-turquesa), Praia Vermelha (areia clara), Praia da Lula (cartão-postal).

**2) Paraísos & Snorkel** (menos movimento): Ilha Comprida (água transparente), Saco da Velha (gruta e costões), Praia da Conceição ou Jurumirim, Lagoa Azul.

**3) Mamanguá Express** (natureza cinematográfica, valor com acréscimo pela distância): Ilha da Cotia (snorkel), Saco do Mamanguá – Praia do Cruzeiro (fiorde tropical), Ilha do Mantimento (opcional).`,
    price: 1300,
    priceUnit: 'casal',
    originalPrice: 1600,
    duration: 'aprox. 5 horas',
    difficulty: 'Fácil',
    tags: ['Fácil', 'Ambiente familiar', 'Aventura', 'Com guia', 'De barco', 'Ideal para casais', 'Ideal para crianças', 'Ideal para famílias', 'Praia', 'Privativo', 'Romântico'],
    imageUrl: 'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/4b01080d-a61a-4c3d-a1cd-f912b1b48c00/w=900',
    status: 'Privativo – até 11 pessoas',
    imagesCount: 6,
    itinerary: [
      'Embarque no Cais de Turismo de Paraty',
      'Escolha do roteiro com o comandante no embarque',
      'Saída para roteiro escolhido (Clássico, Paraísos & Snorkel ou Mamanguá Express)',
      'Paradas para banho e snorkel em praias e ilhas',
      'Tempo livre para fotos, relaxamento e mergulho',
      'Retorno ao Cais de Turismo',
    ],
    included: [
      'Lancha privativa com comandante',
      'Cooler com gelo (traga suas bebidas e lanches)',
      'Máscaras de mergulho e coletes salva-vidas',
      'Paradas para banho e fotos em praias e ilhas',
    ],
    notIncluded: [
      'Almoço e bebidas',
      'Roteiro Mamanguá Express tem acréscimo no valor',
    ],
    bringItems: [
      'Protetor solar',
      'Toalha',
      'Água e bebidas (no cooler incluso)',
      'Lanchinhos',
      'Óculos de sol',
      'Roupa de banho',
      'Camiseta UV e capa à prova d\'água para celular (opcional)',
    ],
    meetingPoint: 'Cais de Turismo de Paraty. Horário a combinar na reserva.',
    startTime: 'A combinar',
    maxGroupSize: '11 pessoas',
    cancellation: 'Você tem direito ao arrependimento e poderá cancelar em até 7 dias após a compra com reembolso de 100%, desde que seja respeitado o prazo de 48 horas antes da data e horário agendado.',
    privacyPolicy: 'Passeio 100% privativo — somente seu grupo na embarcação. Roteiro flexível ajustado conforme clima, maré e preferência do grupo. Rota Mamanguá sujeita a condições de mar/vento.',
    importantNotes: [
      'Roteiro escolhido no embarque',
      'Roteiro Mamanguá Express tem acréscimo no valor',
      'Traga bebidas e lanchinhos (cooler incluso)',
    ],
    gallery: [
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/4b01080d-a61a-4c3d-a1cd-f912b1b48c00/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/d430e566-94e0-4a2b-89a0-35bf84469600/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/2cdf4e3f-3b4f-4339-3f12-74e3a05a9e00/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/e0b842b7-e947-4345-1d5d-4db200605f00/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/b08f3f5f-b7cb-4d79-ee35-3b8a7f495d00/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/8e58878d-e1af-43ad-a252-3b9594b19900/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/4b01080d-a61a-4c3d-a1cd-f912b1b48c00/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/d430e566-94e0-4a2b-89a0-35bf84469600/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/2cdf4e3f-3b4f-4339-3f12-74e3a05a9e00/w=900',
    ],
    relatedTourIds: ['lancha-privativa-em-paraty-calobe', 'passeio-de-lancha-privativa-na-baia-de-paraty-lancha-babi-20263', 'lancha-privada-madame'],
  },
  {
    id: '9',
    slug: 'lancha-privativa-em-paraty-calobe',
    title: 'Passeio de Lancha Privativa na Baía de Paraty – Lancha Calm Sea',
    subtitle: 'Privativo – até 6 pessoas',
    description: 'Passeio privativo de lancha por 5 horas na Baía de Paraty com roteiro flexível — você escolhe o percurso no embarque. Cooler, máscaras e coletes inclusos.',
    longDescription: `A Lancha Calm Sea é perfeita para casais e famílias pequenas de até 6 pessoas que buscam exclusividade e conforto na Baía de Paraty.

O passeio tem duração de 5 horas com roteiro flexível — você escolhe no embarque o percurso preferido.

**Roteiros disponíveis:**

**1) Clássico Baía de Paraty** (TOP para primeira vez): Ilha dos Cocos (snorkel – aquário natural), Lagoa Azul (piscina azul-turquesa), Praia Vermelha (areia clara), Praia da Lula (cartão-postal).

**2) Paraísos & Snorkel** (menos movimento): Ilha Comprida, Saco da Velha, Praia da Conceição ou Jurumirim, Lagoa Azul.

**3) Mamanguá Express** (valor com acréscimo pela distância): Ilha da Cotia, Saco do Mamanguá – Praia do Cruzeiro, Ilha do Mantimento.`,
    price: 1500,
    priceUnit: 'casal',
    originalPrice: 1600,
    duration: 'aprox. 5 horas',
    difficulty: 'Fácil',
    tags: ['Fácil', 'Ambiente familiar', 'Aventura', 'Com guia', 'De barco', 'Ideal para casais', 'Ideal para crianças', 'Ideal para famílias', 'Praia', 'Privativo', 'Romântico'],
    imageUrl: 'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/23667852-e5c2-4da8-1e4e-c3587d7eec00/w=900',
    status: 'Privativo',
    imagesCount: 5,
    itinerary: [
      'Embarque no Cais de Turismo de Paraty',
      'Escolha do roteiro com o comandante no embarque',
      'Navegação pelo roteiro escolhido',
      'Paradas para banho e snorkel em praias e ilhas',
      'Retorno ao Cais de Turismo',
    ],
    included: [
      'Lancha privativa com comandante',
      'Cooler com gelo (traga suas bebidas e lanches)',
      'Máscaras de mergulho e coletes salva-vidas',
      'Paradas para banho e fotos em praias e ilhas',
    ],
    notIncluded: [
      'Almoço e bebidas',
      'Roteiro Mamanguá Express tem acréscimo no valor',
    ],
    bringItems: [
      'Protetor solar',
      'Toalha',
      'Água e bebidas',
      'Lanchinhos',
      'Óculos de sol',
      'Roupa de banho',
    ],
    meetingPoint: 'Cais de Turismo de Paraty.',
    startTime: 'A combinar',
    maxGroupSize: '6 pessoas',
    cancellation: 'Cancelamento grátis até 48 horas antes.',
    privacyPolicy: 'Passeio 100% privativo. Roteiro ajustável conforme clima, maré e preferência. Rota Mamanguá sujeita a condições de mar/vento.',
    importantNotes: [
      'Roteiro escolhido no embarque',
      'Ideal para casais e famílias pequenas',
      'Traga bebidas e lanches (cooler incluso)',
    ],
    gallery: [
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/23667852-e5c2-4da8-1e4e-c3587d7eec00/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/0e1b3f90-718b-4ee2-85b6-6a8368eb2a00/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/0fc7359c-06aa-4747-7327-693cc6fa3f00/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/1c19108f-12d8-4ceb-618a-40520e092500/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/9aaa6fb1-be5f-46a4-547e-8075518d4500/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/23667852-e5c2-4da8-1e4e-c3587d7eec00/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/0e1b3f90-718b-4ee2-85b6-6a8368eb2a00/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/0fc7359c-06aa-4747-7327-693cc6fa3f00/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/1c19108f-12d8-4ceb-618a-40520e092500/w=900',
    ],
    relatedTourIds: ['passeio-de-lancha-privativa-na-baia-de-paraty-20262', 'passeio-de-lancha-privativa-na-baia-de-paraty-lancha-babi-20263', 'lancha-privada-praiana'],
  },
  {
    id: '10',
    slug: 'passeio-de-lancha-privativa-na-baia-de-paraty-lancha-babi-20263',
    title: 'Passeio de Lancha Privativa na Baía de Paraty – LANCHA CABOLE',
    subtitle: 'Privativo – até 11 pessoas',
    description: 'Passeio privativo de lancha por 5 horas na Baía de Paraty. Roteiro flexível, cooler, máscaras e coletes inclusos. Exclusivo para seu grupo!',
    longDescription: `A Lancha Cabole é uma embarcação espaçosa e confortável, ideal para grupos de até 11 pessoas que buscam exclusividade na Baía de Paraty.

O passeio tem duração de 5 horas com roteiro 100% personalizável — você escolhe no embarque o percurso de sua preferência.

**Roteiros disponíveis:**

**1) Clássico Baía de Paraty** (TOP para primeira vez): Ilha dos Cocos, Lagoa Azul, Praia Vermelha, Praia da Lula.

**2) Paraísos & Snorkel** (menos movimento): Ilha Comprida, Saco da Velha, Praia da Conceição ou Jurumirim, Lagoa Azul.

**3) Mamanguá Express** (valor com acréscimo): Ilha da Cotia, Saco do Mamanguá, Ilha do Mantimento.`,
    price: 1450,
    priceUnit: 'casal',
    originalPrice: 1600,
    duration: 'aprox. 5 horas',
    difficulty: 'Fácil',
    tags: ['Fácil', 'Ambiente familiar', 'Aventura', 'Com guia', 'De barco', 'Ideal para casais', 'Ideal para crianças', 'Ideal para famílias', 'Praia', 'Privativo', 'Romântico'],
    imageUrl: 'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/7662061c-665b-44cb-c42b-9f1dbca09900/w=900',
    status: 'Privativo',
    imagesCount: 6,
    itinerary: [
      'Embarque no Cais de Turismo de Paraty',
      'Escolha do roteiro com o comandante',
      'Navegação pelo roteiro escolhido',
      'Paradas para banho e snorkel',
      'Retorno ao Cais',
    ],
    included: [
      'Lancha privativa com comandante',
      'Cooler com gelo',
      'Máscaras de mergulho e coletes salva-vidas',
      'Paradas para banho e fotos',
    ],
    notIncluded: [
      'Almoço e bebidas',
      'Roteiro Mamanguá Express tem acréscimo',
    ],
    bringItems: [
      'Protetor solar',
      'Toalha',
      'Água e bebidas',
      'Lanchinhos',
      'Óculos de sol',
      'Roupa de banho',
    ],
    meetingPoint: 'Cais de Turismo de Paraty.',
    startTime: 'A combinar',
    maxGroupSize: '11 pessoas',
    cancellation: 'Cancelamento grátis até 48 horas antes.',
    privacyPolicy: 'Passeio 100% privativo. Roteiro ajustável conforme clima e maré.',
    importantNotes: [
      'Roteiro escolhido no embarque',
      'Traga bebidas e lanches (cooler incluso)',
      'Roteiro Mamanguá Express tem acréscimo no valor',
    ],
    gallery: [
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/7662061c-665b-44cb-c42b-9f1dbca09900/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/7b4ea8a1-3a1c-449a-7619-b2a156181000/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/3262c572-4e66-4ca8-bcef-fc032235b300/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/27a4cb92-6bcf-451d-7d3e-66ae43c0d900/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/4e63434d-43f6-4073-d28d-9e7a9afc8100/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/6c378cee-7c83-4f82-5be8-3944874f0a00/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/7662061c-665b-44cb-c42b-9f1dbca09900/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/7b4ea8a1-3a1c-449a-7619-b2a156181000/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/3262c572-4e66-4ca8-bcef-fc032235b300/w=900',
    ],
    relatedTourIds: ['passeio-de-lancha-privativa-na-baia-de-paraty-20262', 'lancha-privativa-em-paraty-calobe', 'lancha-privada-madame'],
  },
  {
    id: '11',
    slug: 'experiencia-privativa-em-paraty-a-bordo-de-uma-escuna-de-luxo',
    title: 'Escuna Completa Privativa de Luxo em Paraty – Só para sua Família',
    subtitle: 'Ideal para casal e pernoite – Amanhece no alto mar',
    description: 'Viva uma experiência exclusiva em Paraty a bordo de uma escuna de luxo privativa, com cabines, cozinha completa, sala climatizada e roteiro 100% personalizável. Opção de pernoite!',
    longDescription: `Esta é a experiência mais exclusiva de Paraty: uma escuna de luxo inteira só para você, sua família ou grupo. Com infraestrutura premium — banheiros privativos, cozinha completa, sala climatizada, deck superior e gerador de energia — a escuna oferece todo o conforto de uma casa flutuante.

O valor é por dia e o passeio é 100% privativo. A duração é personalizada: você define os dias e noites. Para pernoite, acréscimo sobre o valor base.

O roteiro é totalmente personalizável: Praia da Lula, Ilha dos Cocos, Ilha Comprida, Praia Vermelha, Saco do Mamanguá, Lagoa Azul e outros destinos secretos. Com capitão e tripulação experientes, bote de apoio para acesso às praias.

Também é possível contratar chef a bordo ou trazer sua própria seleção de alimentos. Decoração em madeira nobre com detalhes clássicos — perfeito para fotos.`,
    price: 4000,
    priceUnit: 'Escuna privada',
    originalPrice: 8000,
    duration: 'Personalizável (valor por dia)',
    difficulty: '',
    tags: ['Ambiente familiar', 'De barco', 'Ideal para famílias', 'Pernoite', 'Praia', 'Privativo'],
    imageUrl: 'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/3c20c61c-3666-40f4-0ddd-4013fca5f800/w=900',
    nextDate: '25/05/2026',
    status: 'Privativo',
    imagesCount: 8,
    itinerary: [
      'Embarque no Cais de Paraty com tour pela escuna',
      'Definição do roteiro com o capitão',
      'Navegação pelas praias e ilhas escolhidas',
      'Paradas para banho, snorkel e stand up paddle',
      '(Pernoite) Jantar romântico e noite a bordo no alto mar',
      '(Pernoite) Café da manhã e nascer do sol',
      'Desembarque no horário combinado',
    ],
    included: [
      'Escuna privativa completa',
      'Capitão, cozinheiro e marinheiro experientes',
      'Cabines confortáveis',
      'Cozinha completa, sala climatizada e deck superior',
      'Bote de apoio para acesso às praias',
      'Banheiros privativos',
      'Gerador de energia',
      'Equipamentos de segurança',
    ],
    notIncluded: [
      'Refeições (possível contratar chef a bordo – consultar)',
      'Bebidas alcoólicas',
      'Pacote pernoite tem acréscimo no valor',
    ],
    bringItems: [
      'Roupas leves',
      'Roupa de banho',
      'Protetor solar',
      'Toalha',
      '(Pernoite) Itens de higiene pessoal',
      'Câmera',
    ],
    meetingPoint: 'Av. Roberto Silveira, 578 – Paraty, RJ. Contato pelo WhatsApp para confirmar detalhes.',
    startTime: 'A combinar',
    maxGroupSize: 'Consultar capacidade',
    cancellation: 'Cancelamento grátis até 7 dias antes. Consultar política para pernoite.',
    privacyPolicy: 'Passeio 100% privativo e acessível para cadeirantes. Roteiro totalmente personalizável. Aplicam-se os termos e condições gerais do site.',
    importantNotes: [
      'Valor por dia – definir quantidade de dias na reserva',
      'Pernoite com acréscimo sobre o valor base',
      'Possível contratar chef a bordo',
      'Contato por WhatsApp para orçamento personalizado',
    ],
    gallery: [
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/3c20c61c-3666-40f4-0ddd-4013fca5f800/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/b4a36d21-611b-4d89-957b-ed6c0d69c500/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/da40726a-cc0e-4746-b882-82d2cbb0ba00/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/03fdde1d-6e3b-4a51-c296-e1760973a900/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/f8770325-b535-461f-7327-af88ac9dd800/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/456e5d7c-9a76-4703-b29e-4e00371c2100/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/780a3b90-2f6f-469c-dbd6-2a3cf9a20200/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/35ab8d3b-8214-4676-e503-f9b329091300/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/44319190-e609-4a7b-a2b4-fbd9260ec500/w=900',
    ],
    relatedTourIds: ['Passeio-em-aquamarina-ll'],
  },
  {
    id: '12',
    slug: 'privativo-lirio-dos-vales',
    title: 'Passeio Privativo de Lancha em Paraty – Lírios dos Vales',
    subtitle: 'Exclusivo e personalizado para seu grupo',
    description: 'Explore as maravilhas de Paraty em um passeio privativo de lancha totalmente personalizado, com conforto e exclusividade a bordo do Lírio dos Vales!',
    longDescription: `A lancha Lírio dos Vales é uma embarcação tradicional e charmosa, perfeita para quem busca um passeio privativo autêntico na Baía de Paraty.

O passeio é totalmente personalizado. Você escolhe as praias e ilhas que quer visitar e o comandante monta o melhor roteiro considerando maré, tempo e suas preferências. É uma experiência genuína, longe das multidões, com tripulação formada por moradores locais que conhecem cada canto da baía e suas histórias.

A lancha conta com som, área de sol, escada de banho e refrigerador.`,
    price: 950,
    priceUnit: 'Grupo',
    duration: 'A combinar',
    difficulty: '',
    tags: ['Ambiente familiar', 'De barco'],
    imageUrl: 'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/88debfda-d4da-4e58-2c32-18156fdeca00/w=900',
    imagesCount: 3,
    itinerary: [
      'Embarque no Cais de Paraty',
      'Definição do roteiro com o comandante',
      'Navegação por praias e ilhas escolhidas',
      'Paradas para banho e snorkel',
      'Almoço opcional em restaurante',
      'Retorno ao cais',
    ],
    included: [
      'Lancha privativa com comandante local',
      'Snorkel',
      'Água e gelo',
      'Som ambiente',
    ],
    notIncluded: [
      'Almoço',
      'Bebidas alcoólicas',
      'Transfer',
    ],
    bringItems: [
      'Protetor solar',
      'Roupa de banho',
      'Toalha',
      'Dinheiro para extras',
    ],
    meetingPoint: 'Cais de Paraty, Centro Histórico.',
    startTime: 'A combinar',
    maxGroupSize: '8 pessoas',
    cancellation: 'Cancelamento grátis até 48h antes.',
    privacyPolicy: 'Passeio privativo. Consultar disponibilidade e orçamento pelo WhatsApp.',
    importantNotes: [
      'Orçamento sob consulta',
      'Roteiro 100% personalizado',
    ],
    gallery: [
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/88debfda-d4da-4e58-2c32-18156fdeca00/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/88debfda-d4da-4e58-2c32-18156fdeca00/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/88debfda-d4da-4e58-2c32-18156fdeca00/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/88debfda-d4da-4e58-2c32-18156fdeca00/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/88debfda-d4da-4e58-2c32-18156fdeca00/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/88debfda-d4da-4e58-2c32-18156fdeca00/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/88debfda-d4da-4e58-2c32-18156fdeca00/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/88debfda-d4da-4e58-2c32-18156fdeca00/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/88debfda-d4da-4e58-2c32-18156fdeca00/w=900',
    ],
    relatedTourIds: ['passeio-privativo-de-lancha-em-paraty-lirios-dos-vales-22435', 'lancha-privada-praiana'],
  },
  {
    id: '13',
    slug: 'lancha-privada-madame',
    title: 'Passeio de Lancha Privada em Paraty: MADAME',
    subtitle: 'Lancha Phoenix Madame – até 7 pessoas',
    description: 'Embarque na Lancha Madame (23,5 pés) para um passeio inesquecível em Paraty com som Bluetooth, snorkel, ducha de água doce, cooler e marinheiro inclusos!',
    longDescription: `A Lancha Madame (Phoenix, 23,5 pés) está pronta para te levar em um passeio privativo com toda a tranquilidade e conforto que o mar de Paraty oferece. Com capacidade para até 7 pessoas, é perfeita para explorar as belezas naturais da região em um ambiente exclusivo.

**Roteiros disponíveis:**
- Roteiro Enseada Vibes
- Roteiro Vibes
- Roteiro Mamanguá
- Roteiro Personalizado

**Serviços inclusos a bordo:**
Sistema de som com Bluetooth, máscaras de snorkel, espaguetes de flutuação, cooler interno com gelo, ducha de água doce, gelo e água mineral de cortesia, marinheiro experiente e combustível.

Ponto de partida: Cais de Turismo de Paraty (horário confirmado na reserva). Entre em contato para consultar disponibilidade e garantir seu passeio exclusivo.`,
    price: 1300,
    priceUnit: 'Grupo',
    duration: 'A combinar',
    difficulty: '',
    tags: ['Ambiente familiar', 'De barco', 'Ideal para casais', 'Ideal para crianças', 'Praia', 'Privativo', 'Romântico'],
    imageUrl: 'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/ca4ed28b-8e81-42d8-940a-bd02490d6200/w=900',
    status: 'Privativo',
    imagesCount: 11,
    itinerary: [
      'Embarque no Cais de Turismo de Paraty (horário confirmado na reserva)',
      'Escolha do roteiro: Enseada Vibes, Vibes, Mamanguá ou Personalizado',
      'Navegação pelas praias e ilhas escolhidas',
      'Paradas para banho, snorkel e relaxamento',
      'Almoço opcional em restaurante à beira-mar',
      'Retorno ao Cais de Turismo',
    ],
    included: [
      'Lancha privativa até 7 pessoas',
      'Marinheiro experiente e combustível',
      'Sistema de som Bluetooth',
      'Máscaras de snorkel',
      'Espaguetes de flutuação',
      'Cooler interno com gelo',
      'Ducha de água doce',
      'Gelo e água mineral de cortesia',
    ],
    notIncluded: [
      'Almoço e bebidas alcoólicas',
      'Transfer',
    ],
    bringItems: [
      'Protetor solar',
      'Roupa de banho',
      'Toalha',
      'Óculos de sol',
      'Dinheiro para extras',
    ],
    meetingPoint: 'Cais de Turismo de Paraty. Horário confirmado na reserva.',
    startTime: 'A combinar',
    maxGroupSize: '7 pessoas',
    cancellation: 'Consultar disponibilidade e política pelo WhatsApp.',
    privacyPolicy: 'Passeio privativo. Orçamento e disponibilidade sob consulta.',
    importantNotes: [
      'Orçamento pelo WhatsApp',
      'Roteiro personalizável no embarque',
    ],
    gallery: [
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/ca4ed28b-8e81-42d8-940a-bd02490d6200/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/e76e2d12-c5e0-4b64-78c3-06c0eda3a300/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/7af71b54-3ba7-4029-b603-4787ff2e0200/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/d5ea7c00-4019-471b-7cd5-256bbf493f00/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/77b542ef-b380-4d64-93a4-070019792d00/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/d6665d0e-75d9-491c-a69d-4da3420b6e00/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/467f1c0c-40fc-4958-60b9-faff859dd700/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/4a48ee22-dbc9-4a08-c544-88be6a987d00/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/62d10193-b454-4bb1-ead9-ac1b84a97600/w=900',
    ],
    relatedTourIds: ['passeio-de-lancha-privativa-na-baia-de-paraty-20262', 'passeio-de-lancha-privativa-na-baia-de-paraty-lancha-babi-20263', 'lancha-privada-vida-boa'],
  },
  {
    id: '14',
    slug: 'passeio-privativo-de-lancha-em-paraty-lirios-dos-vales-22435',
    title: 'Passeio Privativo em Paraty – Capitão NY',
    subtitle: 'Experiência autêntica com morador local',
    description: 'Explore as maravilhas de Paraty em um passeio privativo de lancha totalmente personalizado, com conforto e exclusividade com o Capitão NY!',
    longDescription: `Com o Capitão NY, você tem um passeio autêntico e descontraído pelas águas de Paraty. O capitão é morador local com anos de experiência navegando a baía, conhecendo cada canto, correnteza e história do lugar.

Este passeio é para quem busca uma experiência genuína, longe dos roteiros turísticos padronizados. O Capitão NY adapta o passeio ao seu perfil — seja aventureiro, romântico ou família com crianças.

A lancha tem som, área de sol e equipamentos de snorkel. O clima é descontraído, com música boa e muitas histórias locais.`,
    price: 1000,
    priceUnit: 'Grupo',
    duration: 'A combinar',
    difficulty: '',
    tags: ['Ambiente familiar', 'De barco'],
    imageUrl: 'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/4ea011a8-859a-4e5a-050b-4dd888e99000/w=900',
    imagesCount: 4,
    itinerary: [
      'Encontro no Cais de Paraty',
      'Bate-papo para entender o perfil do grupo',
      'Roteiro personalizado com o Capitão NY',
      'Navegação por praias e ilhas',
      'Paradas para banho e snorkel',
      'Almoço opcional',
      'Retorno ao cais',
    ],
    included: [
      'Lancha privativa com Capitão NY (guia local experiente)',
      'Combustível',
      'Snorkel',
      'Água e gelo',
      'Som Bluetooth',
    ],
    notIncluded: [
      'Almoço',
      'Bebidas alcoólicas',
      'Transfer',
    ],
    bringItems: [
      'Protetor solar',
      'Roupa de banho',
      'Toalha',
      'Dinheiro para extras',
      'Bom humor!',
    ],
    meetingPoint: 'Cais de Paraty, Centro Histórico.',
    startTime: 'A combinar',
    maxGroupSize: '8 pessoas',
    cancellation: 'Cancelamento grátis até 48h antes.',
    privacyPolicy: 'Passeio privativo. Orçamento sob consulta.',
    importantNotes: [
      'Roteiro 100% personalizado',
      'Orçamento pelo WhatsApp',
    ],
    gallery: [
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/4ea011a8-859a-4e5a-050b-4dd888e99000/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/4ea011a8-859a-4e5a-050b-4dd888e99000/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/4ea011a8-859a-4e5a-050b-4dd888e99000/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/4ea011a8-859a-4e5a-050b-4dd888e99000/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/4ea011a8-859a-4e5a-050b-4dd888e99000/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/4ea011a8-859a-4e5a-050b-4dd888e99000/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/4ea011a8-859a-4e5a-050b-4dd888e99000/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/4ea011a8-859a-4e5a-050b-4dd888e99000/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/4ea011a8-859a-4e5a-050b-4dd888e99000/w=900',
    ],
    relatedTourIds: ['privativo-lirio-dos-vales', 'lancha-privada-praiana'],
  },
  {
    id: '16',
    slug: 'lancha-privada-praiana',
    title: 'Lancha Privada em Paraty – Praiana',
    subtitle: 'Até 7 pessoas – 5 a 6 horas com até 5 paradas',
    description: 'Descubra o paraíso com passeio de lancha privada em Paraty! Máscaras, flutuadores, coletes, ducha, cooler, água mineral, som Bluetooth e marinheiro inclusos.',
    longDescription: `Descubra o paraíso em um passeio de lancha privada pelas águas cristalinas de Paraty. Ideal para famílias, o passeio oferece uma experiência personalizada com duração de 5 a 6 horas e até 5 paradas incríveis.

Cada roteiro é adaptado ao perfil dos clientes, permitindo a personalização dos horários de saída e duração de cada parada. A equipe cuida de todos os detalhes para garantir conforto e segurança.

A bordo você encontra máscaras de snorkel, flutuadores, coletes salva-vidas, ducha de água doce, toalhas, cooler com gelo filtrado, água mineral, som Bluetooth, marinheiro à disposição e 1 cortesia especial (consultar ao fechar).`,
    price: 1400,
    priceUnit: 'Grupo',
    duration: '5 a 6 horas',
    difficulty: '',
    tags: ['Ideal para famílias', 'Praia', 'Privativo'],
    imageUrl: 'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/0a6a2d73-cb11-430f-e6b1-0601ae918100/w=900',
    imagesCount: 3,
    itinerary: [
      'Embarque no Cais de Paraty (horário personalizável)',
      'Roteiro personalizado com o comandante',
      'Navegação por praias e ilhas paradisíacas',
      'Até 5 paradas para banho, snorkel e relaxamento',
      'Almoço opcional em restaurante à beira-mar',
      'Retorno ao Cais de Paraty',
    ],
    included: [
      'Lancha privativa até 7 pessoas',
      'Marinheiro à disposição e combustível',
      'Máscaras de snorkel',
      'Flutuadores',
      'Coletes salva-vidas',
      'Ducha de água doce',
      'Toalhas',
      'Cooler com gelo filtrado',
      'Água mineral',
      'Som Bluetooth',
      '1 cortesia a bordo (consultar)',
    ],
    notIncluded: [
      'Almoço',
      'Bebidas alcoólicas',
      'Transfer',
    ],
    bringItems: [
      'Protetor solar',
      'Roupa de banho',
      'Óculos de sol',
      'Dinheiro para extras',
    ],
    meetingPoint: 'Cais de Paraty, RJ.',
    startTime: 'A combinar',
    maxGroupSize: '7 pessoas',
    cancellation: 'Consultar disponibilidade e política pelo WhatsApp.',
    privacyPolicy: 'Passeio privativo. Orçamento sob consulta.',
    importantNotes: [
      'Roteiro personalizado com até 5 paradas',
      'Horário de saída personalizável',
      'Perguntar sobre a cortesia ao fechar',
    ],
    gallery: [
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/0a6a2d73-cb11-430f-e6b1-0601ae918100/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/693e0b21-3b4f-4693-22fd-6f8955b2e000/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/6a72b6ed-c9ec-41a6-1085-fb9940755b00/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/0a6a2d73-cb11-430f-e6b1-0601ae918100/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/693e0b21-3b4f-4693-22fd-6f8955b2e000/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/6a72b6ed-c9ec-41a6-1085-fb9940755b00/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/0a6a2d73-cb11-430f-e6b1-0601ae918100/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/693e0b21-3b4f-4693-22fd-6f8955b2e000/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/6a72b6ed-c9ec-41a6-1085-fb9940755b00/w=900',
    ],
    relatedTourIds: ['privativo-lirio-dos-vales', 'passeio-privativo-de-lancha-em-paraty-lirios-dos-vales-22435'],
  },
  {
    id: '17',
    slug: 'lancha-privada-vida-boa',
    title: 'Passeio de Lancha Privada, Paraty-RJ – PHOENIX Vida Boa',
    subtitle: 'Até 9 pessoas – Diversão garantida no mar!',
    description: 'Descubra a beleza de Paraty a bordo da lancha privada Phoenix Vida Boa, explorando roteiros incríveis com conforto, som potente e exclusividade!',
    longDescription: `A Lancha Phoenix Vida Boa é o sinônimo de diversão e boa energia em Paraty. Com capacidade para até 9 pessoas, é perfeita para grupos que querem aproveitar um dia de sol, música e praias paradisíacas com total privacidade.

O design da lancha prioriza o espaço social, com área de convés generosa, som potente, cooler grande e toldo para área de sombra. Ideal para despedidas de solteiro, aniversários, confraternizações ou simplesmente um dia animado com amigos.

O roteiro é personalizado e o comandante sabe exatamente onde levar você para aproveitar o melhor de cada parada.`,
    price: 1650,
    priceUnit: 'Grupo',
    duration: 'A combinar',
    difficulty: '',
    tags: ['Ambiente familiar', 'Dia inteiro', 'Ideal para casais', 'Privativo'],
    imageUrl: 'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/83b60127-1a1e-46d4-965a-3024538dc300/w=900',
    imagesCount: 4,
    itinerary: [
      'Saída do Cais de Paraty com boas-vindas',
      'Roteiro planejado conforme perfil do grupo',
      'Navegação por praias e ilhas da baía',
      'Paradas para banho, snorkel e stand up paddle',
      'Almoço opcional em restaurante',
      'Retorno ao cais',
    ],
    included: [
      'Lancha privativa até 9 pessoas',
      'Comandante e marinheiro',
      'Combustível',
      'Snorkel e stand up paddle',
      'Água, gelo e cooler',
      'Som Bluetooth potente',
    ],
    notIncluded: [
      'Almoço',
      'Bebidas alcoólicas',
      'Transfer',
    ],
    bringItems: [
      'Protetor solar',
      'Roupa de banho',
      'Toalha',
      'Óculos de sol',
      'Playlist animada no celular',
      'Dinheiro para extras',
    ],
    meetingPoint: 'Cais de Paraty, Centro Histórico.',
    startTime: 'A combinar',
    maxGroupSize: '9 pessoas',
    cancellation: 'Cancelamento grátis até 48h antes.',
    privacyPolicy: 'Passeio privativo. Orçamento sob consulta.',
    importantNotes: [
      'Ideal para grupos animados e festivos',
      'Roteiro 100% personalizado',
    ],
    gallery: [
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/83b60127-1a1e-46d4-965a-3024538dc300/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/83b60127-1a1e-46d4-965a-3024538dc300/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/83b60127-1a1e-46d4-965a-3024538dc300/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/83b60127-1a1e-46d4-965a-3024538dc300/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/83b60127-1a1e-46d4-965a-3024538dc300/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/83b60127-1a1e-46d4-965a-3024538dc300/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/83b60127-1a1e-46d4-965a-3024538dc300/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/83b60127-1a1e-46d4-965a-3024538dc300/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/83b60127-1a1e-46d4-965a-3024538dc300/w=900',
    ],
    relatedTourIds: ['passeio-de-lancha-privativa-na-baia-de-paraty-20262', 'passeio-de-lancha-privativa-na-baia-de-paraty-lancha-babi-20263', 'lancha-privada-madame'],
  },
  {
    id: '18',
    slug: 'passeio-em-escuna-poseidon',
    title: 'Escuna Poseidon — Roteiro Norte | Paraty, RJ',
    subtitle: 'Escuna Nova e Moderna – Roteiro Norte Exclusivo com Praias Paradisíacas',
    description: 'Esqueça o roteiro tradicional! Navegue pelo litoral mais preservado de Paraty a bordo da Escuna Poseidon, uma embarcação nova e moderna com roteiro exclusivo pelo lado Norte — praias tranquilas, águas cristalinas e cenários perfeitos.',
    longDescription: `<p>Esqueça o roteiro tradicional e prepare-se para viver uma experiência única navegando pelo litoral mais preservado de Paraty. A <strong>Escuna Poseidon</strong> é nova, moderna e oferece conforto, diversão e paisagens paradisíacas em um roteiro exclusivo pelo lado Norte, conhecido por suas praias tranquilas, águas cristalinas e menor fluxo de visitantes.</p>
<p>Ideal para quem busca contato com a natureza, momentos de descanso e cenários perfeitos para fotos inesquecíveis.</p>
<h3>✨ O que está incluso no passeio</h3>
<p>Ao reservar seu passeio na <strong>Escuna Poseidon I</strong>, você garante uma experiência completa e inesquecível:</p>
<ul>
<li>✅ <strong>Passeio de escuna com roteiro Norte</strong>, com 4 paradas em locais paradisíacos</li>
<li>✅ <strong>Wi-Fi via Starlink</strong> – conexão disponível durante todo o passeio</li>
<li>✅ <strong>Escorregador triplo</strong> – diversão garantida para adultos e crianças</li>
<li>✅ <strong>Bote de apoio</strong> – mais conforto e facilidade para chegar às praias</li>
<li>✅ <strong>Áreas instagramáveis</strong> – perfeitas para fotos incríveis</li>
<li>✅ <strong>Paradas para mergulho e banho</strong> em águas calmas e cristalinas</li>
<li>✅ <strong>Tripulação experiente</strong>, garantindo segurança e tranquilidade</li>
</ul>
<h3>🏝️ Roteiro Norte – Paradas do Passeio</h3>
<p><strong>🏝️ Ilha do Marbão</strong> – Primeira parada, famosa por águas calmas e transparentes. Ótima para banho, flutuação e relaxamento. Ilha tranquila e pouco movimentada.</p>
<p><strong>🏝️ Ilha da Rapada</strong> – Um dos pontos mais preservados da região Norte. Mar limpo com excelente visibilidade para mergulho. Ambiente reservado e natural.</p>
<p><strong>🏖️ Praia de Comprida do Norte</strong> – Praia extensa de águas claras e calmas. Por estar no roteiro Norte, costuma ser mais vazia e tranquila, perfeita para famílias.</p>
<p><strong>🏖️ Praia do Rosa 🌹</strong> – Última parada do passeio. Praia charmosa cercada por natureza, clima rústico e acolhedor. Perfeita para o último mergulho e fotos incríveis.</p>
<h3>🕒 Duração & Horários</h3>
<p>🛥️ <strong>Saída:</strong> às 11h do Cais de Turismo de Paraty<br>🕟 <strong>Retorno:</strong> por volta das 17h<br>⏱️ <strong>Duração total:</strong> aproximadamente 6 horas de passeio</p>
<h3>🍽️ Alimentação & Bebidas</h3>
<p>A escuna conta com <strong>serviço de bar e restaurante a bordo</strong> (opcional, pago à parte): 🍤 Petiscos • 🍽️ Refeições • 🐟 Peixes • 🍹 Drinks • 🥤 Bebidas alcoólicas e não alcoólicas</p>
<h3>👨‍👩‍👧 Público</h3>
<p>✔️ Ideal para <strong>famílias, casais e grupos de amigos</strong><br>✔️ Crianças são bem-vindas (coletes salva-vidas disponíveis a bordo)<br>✔️ Passeio tranquilo, seguro e confortável</p>
<h3>📸 Diferenciais da Escuna Poseidon I</h3>
<p>✨ Escuna nova e bem equipada<br>✨ Roteiro Norte com praias mais vazias e tranquilas<br>✨ Estrutura moderna e confortável<br>✨ Ambientes perfeitos para fotos e vídeos<br>✨ Experiência completa de lazer e descanso</p>
<h3>📍 Ponto de Encontro</h3>
<p>📌 <strong>Cais de Turismo de Paraty – Centro Histórico</strong><br>⏰ Recomendamos chegar <strong>30 minutos antes do embarque</strong></p>
<h3>✅ Dicas importantes</h3>
<p>✔️ Levar roupa de banho e toalha<br>✔️ Protetor solar, chapéu/boné e óculos de sol<br>✔️ Dinheiro ou cartão para consumo a bordo<br>✔️ Em dias de mar agitado, há áreas internas cobertas para maior conforto</p>`,
    price: 130,
    priceUnit: 'Adulto',
    originalPrice: 150,
    duration: 'aprox. 6 horas',
    difficulty: 'Fácil',
    tags: ['Fácil', 'Aventura', 'Com guia', 'De barco', 'Dia inteiro', 'Ideal para famílias', 'Ideal para casais'],
    imageUrl: 'https://storage.helloreaddy.io/project_files/7c7802d6-a309-4e70-ba60-a9d8c5ce7dd4/69e412a1-7234-4e74-b710-16446654cc6b_1000130639.jpg',
    nextDate: '02/08/2026',
    status: 'Vagas Limitadas',
    imagesCount: 10,
    itinerary: [
      'Saída às 11h do Cais de Turismo de Paraty – chegue 30 min antes',
      '1ª Parada: Ilha do Marbão – águas calmas e transparentes, perfeita para banho e flutuação',
      '2ª Parada: Ilha da Rapada – ponto preservado com excelente visibilidade para mergulho',
      '3ª Parada: Praia de Comprida do Norte – praia extensa de águas claras, tranquila e ideal para famílias',
      '4ª Parada: Praia do Rosa – charmosa e cercada por natureza, último mergulho antes do retorno',
      'Retorno ao Cais de Turismo de Paraty por volta das 17h',
    ],
    included: [
      'Passeio de 6 horas a bordo da Escuna Poseidon I',
      'Roteiro Norte exclusivo com 4 paradas em locais paradisíacos',
      'Wi-Fi via Starlink durante todo o passeio',
      'Escorregador triplo – diversão para adultos e crianças',
      'Bote de apoio para desembarque nas praias',
      'Áreas instagramáveis para fotos incríveis',
      'Paradas para mergulho e banho em águas cristalinas',
      'Tripulação experiente',
      'Som ambiente',
      'Banheiros a bordo',
      'Colete salva-vidas disponível',
    ],
    notIncluded: [
      'Bebidas e alimentos (adquiridos no bar/restaurante a bordo, pago à parte)',
      'Equipamentos de mergulho',
      'Transfer de hotel',
    ],
    bringItems: [
      'Roupa de banho',
      'Toalha',
      'Protetor solar (obrigatório)',
      'Chapéu ou boné',
      'Óculos de sol',
      'Dinheiro ou cartão para consumo a bordo',
      'Câmera ou celular para fotos',
    ],
    meetingPoint: 'Cais de Turismo de Paraty – Centro Histórico. Recomendamos chegar 30 minutos antes do embarque.',
    startTime: '11:00',
    maxGroupSize: 'Escuna coletiva',
    cancellation: 'Você tem direito ao arrependimento e poderá cancelar em até 7 dias após a compra com reembolso de 100%, desde que seja respeitado o prazo de 24 horas antes da data e horário do agendamento. Troca de data sem custo algum.',
    privacyPolicy: 'PROIBIDO EMBARQUE COM BEBIDAS OU ALIMENTOS. Somente serão autorizados mediante prévia coordenação com o responsável. Aplicam-se também os termos e condições gerais disponíveis no site.',
    importantNotes: [
      'Chegar 30 minutos antes do embarque para check-in',
      'Saída às 11h do Cais de Turismo de Paraty',
      'Em dias de mar agitado, há áreas internas cobertas para maior conforto',
      'Crianças bem-vindas com colete salva-vidas disponível a bordo',
      'Bar e restaurante disponíveis a bordo (pago à parte)',
      'Duração total de aproximadamente 6 horas',
    ],
    gallery: [
      'https://storage.helloreaddy.io/project_files/7c7802d6-a309-4e70-ba60-a9d8c5ce7dd4/69e412a1-7234-4e74-b710-16446654cc6b_1000130639.jpg',
      'https://readdy.ai/api/search-image?query=A%20modern%20white%20schooner%20boat%20sailing%20on%20crystal%20clear%20turquoise%20waters%20near%20tropical%20green%20islands%20in%20Paraty%20Brazil%2C%20bright%20sunny%20day%2C%20professional%20travel%20photography%2C%20vibrant%20colors&width=900&height=600&seq=poseidon-gallery-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Tropical%20beach%20with%20calm%20crystal%20clear%20water%20and%20white%20sand%20surrounded%20by%20lush%20Atlantic%20Forest%20mountains%20in%20Paraty%20Brazil%2C%20paradise%20landscape%2C%20no%20people%2C%20bright%20sunlight&width=900&height=600&seq=poseidon-gallery-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=People%20swimming%20and%20snorkeling%20in%20transparent%20turquoise%20water%20near%20a%20white%20boat%20at%20a%20tropical%20island%20in%20Brazil%2C%20happy%20vacation%20atmosphere%2C%20sunny%20day%2C%20travel%20lifestyle%20photography&width=900&height=600&seq=poseidon-gallery-3&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Drone%20aerial%20view%20of%20a%20beautiful%20tropical%20bay%20with%20emerald%20green%20water%20and%20small%20islands%20in%20Paraty%20Brazil%2C%20stunning%20coastal%20landscape%2C%20atlantic%20forest%20covering%20the%20mountains&width=900&height=600&seq=poseidon-gallery-4&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Tourists%20enjoying%20a%20boat%20trip%20with%20water%20slide%20on%20a%20schooner%20in%20tropical%20waters%20Brazil%2C%20fun%20summer%20vacation%2C%20bright%20colors%2C%20joyful%20atmosphere%2C%20travel%20photography&width=900&height=600&seq=poseidon-gallery-5&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Secluded%20tropical%20beach%20with%20pink%20sand%20and%20calm%20blue%20water%20surrounded%20by%20green%20hills%20in%20Brazil%2C%20paradise%20setting%2C%20no%20people%2C%20pristine%20nature%2C%20travel%20destination&width=900&height=600&seq=poseidon-gallery-6&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Historic%20colonial%20pier%20in%20Paraty%20Brazil%20with%20colorful%20boats%20docked%2C%20cobblestone%20streets%20and%20white%20buildings%20in%20background%2C%20warm%20afternoon%20light%2C%20travel%20photography&width=900&height=600&seq=poseidon-gallery-7&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Group%20of%20friends%20taking%20photos%20on%20a%20beautiful%20boat%20deck%20with%20tropical%20island%20background%20Brazil%2C%20instagram%20worthy%20spot%2C%20happy%20vibes%2C%20summer%20travel%20lifestyle&width=900&height=600&seq=poseidon-gallery-8&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Sunset%20view%20from%20a%20boat%20deck%20over%20the%20bay%20of%20Paraty%20with%20mountains%20silhouette%2C%20golden%20hour%20light%2C%20peaceful%20atmosphere%2C%20romantic%20travel%20scene&width=900&height=600&seq=poseidon-gallery-9&orientation=landscape',
    ],
    relatedTourIds: ['Passeio-em-aquamarina-ll', 'experiencia-privativa-em-paraty-a-bordo-de-uma-escuna-de-luxo'],
  },
  {
    id: '19',
    slug: 'expedicao-salar-de-uyuni-3-dias',
    title: 'Expedição Salar de Uyuni 3 Dias — A Maior Aventura da Bolívia',
    subtitle: 'Conheça o maior deserto de sal do mundo — uma jornada inesquecível pelo Altiplano Boliviano',
    description: 'Viva 3 dias de aventura no maior deserto de sal do mundo! Explore o Salar de Uyuni, lagoas coloridas, vulcões, gêiseres e paisagens de outro mundo no Altiplano Boliviano.',
    longDescription: `<h2>🌎 A Maior Aventura da Sua Vida Começa na Bolívia</h2>

<p>Prepare-se para viver <strong>3 dias inesquecíveis</strong> explorando o lendário <strong>Salar de Uyuni</strong> — o maior e mais espetacular deserto de sal do planeta — e as paisagens surreais do <strong>Altiplano Boliviano</strong>. Esta não é uma simples viagem, é uma <strong>expedição completa</strong> que vai transformar sua forma de ver o mundo.</p>

<hr />

<h2>🛬 COMO CHEGAR — O PONTO DE PARTIDA É LA PAZ</h2>

<p>O turista deve chegar em <strong>La Paz, Bolívia</strong>, onde começa toda a aventura. De La Paz até Uyuni, oferecemos duas opções de traslado que você pode escolher conforme sua preferência e orçamento:</p>

<p><strong>🚌 Opção 1 — Ônibus Leito Noturno (incluído no pacote):</strong> Saída de La Paz por volta das 21h, em ônibus leito confortável com poltronas reclináveis, banheiro a bordo e ar quente. A viagem dura aproximadamente 10 a 12 horas, chegando em Uyuni no início da manhã do dia seguinte. É uma ótima opção para quem quer economizar e já chegar pronto para começar a expedição.</p>

<p><strong>✈️ Opção 2 — Voo Doméstico La Paz → Uyuni (adicional não incluso):</strong> Para quem prefere mais conforto e rapidez, existe a opção de voo direto de La Paz a Uyuni, com duração de aproximadamente 1 hora. As companhias aéreas BoA (Boliviana de Aviación) operam este trecho. Consulte-nos para valores e disponibilidade.</p>

<p><strong>🗓️ Recomendação importante:</strong> Sugerimos que você chegue em La Paz com pelo menos <strong>1 dia de antecedência</strong> para aclimatação à altitude. La Paz está a 3.640 metros acima do nível do mar, e durante a expedição você alcançará altitudes de até 5.000 metros. Isso ajuda seu corpo a se adaptar e evita desconfortos durante o passeio.</p>

<hr />

<h2>🚙 A EXPEDIÇÃO — 3 DIAS PELO ALTIPLANO</h2>

<p>A expedição propriamente dita <strong>começa em Uyuni</strong> às 10h30 da manhã. Você será recebido por nossa equipe e apresentado ao <strong>motorista-guia experiente</strong> que o acompanhará durante toda a jornada. O veículo é um <strong>4x4 Toyota Land Cruiser</strong> ou similar, o mais adequado para os terrenos do Altiplano, com capacidade para até 6 passageiros em grupos reduzidos — nada de ônibus lotados.</p>

<p>A expedição percorre um dos roteiros mais impressionantes da América do Sul: você atravessará o imenso Salar de Uyuni com seu horizonte infinito branco, visitará a mágica Ilha Incahuasi coberta de cactos gigantes centenários, observará flamingos andinos em lagoas de cores surreais, caminhará entre gêiseres fumegantes a quase 5.000 metros de altitude, e relaxará em fontes termais naturais cercado por vulcões nevados.</p>

<p>Cada parada foi cuidadosamente planejada para que você aproveite ao máximo cada cenário. Seu guia conhece os melhores ângulos para fotos, os horários ideais de luz e as histórias fascinantes de cada lugar.</p>

<hr />

<h2>🍽️ ALIMENTAÇÃO — TUDO INCLUSO</h2>

<p><strong>Todas as refeições durante os 3 dias estão incluídas no pacote.</strong> Isso significa café da manhã, almoço e jantar todos os dias, preparados com ingredientes frescos e adaptados ao paladar brasileiro sempre que possível. As refeições são servidas em restaurantes locais durante as paradas ou preparadas pela equipe em pontos estratégicos com vistas incríveis — como almoçar no meio do Salar de Uyuni, cercado pelo branco infinito.</p>

<p><strong>Bebidas não alcoólicas</strong> (água, sucos, refrigerantes) também estão incluídas durante as refeições. Bebidas alcoólicas e snacks extras podem ser adquiridos nas paradas e não estão inclusos.</p>

<hr />

<h2>🛏️ HOSPEDAGEM — COMPARTILHADA INCLUSA, PRIVATIVA OPCIONAL</h2>

<p><strong>As 2 noites de hospedagem estão incluídas no pacote</strong> na modalidade <strong>compartilhada</strong> (quartos com 2 a 4 pessoas, separados por gênero ou grupos familiares). As hospedagens no Altiplano são simples, limpas e aconchegantes, construídas com materiais locais e equipadas com banheiros, água quente e aquecimento. Fazem parte da experiência autêntica da região.</p>

<p><strong>🌙 Quer mais privacidade?</strong> Se você prefere um quarto só para você ou para seu casal, oferecemos a opção de <strong>hospedagem privativa com adicional de US$ 40 por pessoa</strong> (para as 2 noites). Basta solicitar no momento da reserva e garantimos quartos privativos nas mesmas hospedagens do roteiro. Sujeito à disponibilidade.</p>

<hr />

<h2>📸 O QUE VOCÊ VAI VER E VIVER</h2>

<p>Durante esta expedição você vai conhecer alguns dos cenários mais impressionantes do planeta:</p>

<ul>
<li><strong>🧂 Salar de Uyuni</strong> — o maior deserto de sal do mundo, com mais de 10.000 km² de superfície branca. Na temporada de chuvas (dezembro a março), uma fina camada de água cria o famoso <strong>efeito espelho</strong>, onde o céu se reflete perfeitamente no chão. Na temporada seca, as formações hexagonais de sal criam um cenário geométrico surreal.</li>

<li><strong>🏝️ Ilha Incahuasi</strong> — uma antiga ilha vulcânica no meio do Salar, coberta por <strong>cactos gigantes de até 12 metros de altura</strong> com mais de 1.200 anos. A trilha até o topo oferece uma vista panorâmica de 360° do Salar que vai tirar seu fôlego.</li>

<li><strong>🚂 Cemitério de Trens</strong> — locomotivas antigas abandonadas no deserto desde o auge da mineração boliviana no século XIX. Um cenário fotográfico impressionante e cheio de história.</li>

<li><strong>🏨 Hotel de Sal</strong> — um hotel construído inteiramente com blocos de sal extraídos do próprio Salar. Paredes, tetos, mesas, camas — tudo feito de sal.</li>

<li><strong>🏁 Monumento Dakar e Praça das Bandeiras</strong> — o famoso monumento que homenageia a passagem do Rally Dakar pelo Salar, e a praça com bandeiras de viajantes do mundo inteiro.</li>

<li><strong>🦩 Laguna Colorada</strong> — uma lagoa de coloração vermelha intensa causada por minerais e algas, habitada por milhares de flamingos andinos. O contraste do vermelho da água com o branco dos flamingos e o azul do céu é simplesmente mágico.</li>

<li><strong>🌋 Gêiseres Sol de Mañana</strong> — campo geotérmico a 4.850 metros de altitude, onde jatos de vapor e lama borbulhante saem da terra ao amanhecer. Um espetáculo que parece de outro planeta.</li>

<li><strong>♨️ Termas de Polques</strong> — piscinas naturais de águas termais quentinhas no meio do Altiplano gelado. Perfeitas para relaxar os músculos depois da expedição.</li>

<li><strong>💚 Laguna Verde</strong> — aos pés do imponente Vulcão Licancabur, suas águas verde-esmeralda são um dos cartões-postais mais famosos da Bolívia.</li>

<li><strong>🪨 Árbol de Piedra</strong> — uma formação rochosa esculpida pelo vento durante milênios no Deserto Siloli, que desafia a gravidade e a lógica.</li>
</ul>

<hr />

<h2>🧳 O QUE LEVAR — GUIA PARA BRASILEIROS</h2>

<p>O Altiplano Boliviano tem um clima extremo e muito diferente do Brasil. Durante o dia, com sol, as temperaturas podem chegar a <strong>15°C a 20°C</strong>. Mas quando o sol se põe, os termômetros despencam para <strong>-10°C a -15°C</strong>. A sensação térmica pode ser ainda menor com o vento. Por isso, é fundamental estar bem preparado:</p>

<ul>
<li>🧥 <strong>Casaco pesado impermeável</strong> (tipo jaqueta de ski ou similares) — essencial e obrigatório</li>
<li>🧤 <strong>Luvas térmicas, gorro e cachecol</strong> — extremidades são as primeiras a sentir o frio</li>
<li>👢 <strong>Bota de trilha ou tênis impermeável</strong> — para caminhar no sal, terra e pedras</li>
<li>🧴 <strong>Protetor solar FPS 50+</strong> — a radiação solar na altitude é extremamente intensa</li>
<li>🕶️ <strong>Óculos de sol com proteção UV</strong> — o branco do Salar reflete a luz e pode machucar os olhos sem proteção</li>
<li>💧 <strong>Hidratante labial e creme hidratante</strong> — o ar é muito seco na altitude</li>
<li>💊 <strong>Medicamentos para altitude</strong> (consulte seu médico antes da viagem) e remédios pessoais</li>
<li>🎒 <strong>Mochila pequena</strong> para levar pertences durante o dia (a bagagem grande fica no veículo)</li>
<li>📷 <strong>Câmera fotográfica com bateria extra</strong> — as hospedagens têm poucas tomadas e a paisagem merece ser registrada</li>
<li>💵 <strong>Dinheiro em Bolivianos (BOB)</strong> para compras pessoais, bebidas extras e lembrancinhas nas comunidades locais</li>
</ul>

<hr />

<h2>⚠️ INFORMAÇÕES IMPORTANTES SOBRE A ALTITUDE</h2>

<p>Esta expedição atinge altitudes de <strong>até 5.000 metros</strong> acima do nível do mar. O ar é mais rarefeito e contém menos oxigênio, o que pode causar desconforto em algumas pessoas (dor de cabeça, náusea, cansaço). Isso é normal e chama-se <strong>soroche</strong> (mal de altitude).</p>

<p><strong>Para minimizar os efeitos:</strong></p>
<ul>
<li>✅ Chegue em La Paz com pelo menos 1 dia de antecedência para aclimatação</li>
<li>✅ Beba MUITA água (mínimo 2 litros por dia)</li>
<li>✅ Evite álcool e refeições pesadas nas primeiras 24 horas</li>
<li>✅ Mastigue folhas de coca ou tome chá de coca (tradição local que ajuda muito)</li>
<li>✅ Caminhe devagar, sem pressa</li>
<li>✅ Consulte seu médico antes da viagem, especialmente se tiver problemas cardíacos ou respiratórios</li>
<li>✅ O guia está treinado para lidar com emergências e o veículo carrega oxigênio suplementar</li>
</ul>

<hr />

<h2>💬 RESUMO FINAL</h2>

<p>Esta é a viagem mais completa para quem quer conhecer a Bolívia de verdade. Você não precisa se preocupar com nada — <strong>transporte, alimentação, hospedagem, guia e todas as visitas estão incluídos</strong>. A única coisa que você precisa fazer é chegar em La Paz com vontade de viver uma aventura inesquecível.</p>

<p>Se tiver qualquer dúvida antes de reservar, entre em contato conosco. Estamos aqui para ajudar você a realizar essa experiência única.</p>

<p><strong>📍 Resumo rápido:</strong> Chegue em La Paz → Traslado incluso para Uyuni (ônibus leito noturno) → 3 dias de expedição 4x4 com tudo incluso → Retorno a Uyuni → Fim da expedição. O retorno a La Paz (ônibus ou voo) é por conta do viajante e pode ser organizado com nossa equipe local.</p>`,
    price: 1200,
    priceUnit: 'pessoa',
    originalPrice: 1500,
    duration: '3 dias / 2 noites',
    difficulty: 'Intermediário',
    tags: ['Aventura', 'Natureza', 'Com guia', '4x4', 'Grupo reduzido', 'Alta altitude'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Stunning%20Salar%20de%20Uyuni%20salt%20flat%20at%20sunset%20with%20reflection%20mirror%20effect%20on%20water%20surface%2C%20endless%20white%20horizon%2C%20dramatic%20clouds%2C%20Bolivia%20altiplano%2C%20travel%20photography%2C%20breathtaking%20landscape%2C%20warm%20golden%20light%2C%20minimalist%20composition%20with%20salt%20hexagons%20texture%20in%20foreground&width=900&height=600&seq=salar-uyuni-hero&orientation=landscape',
    nextDate: '20/07/2026',
    status: 'Vagas Limitadas',
    imagesCount: 15,
    itinerary: [
      '🛬 Chegada em La Paz — cidade base onde o viajante deve estar para iniciar a expedição. Recomendamos 1 dia de aclimatação à altitude (3.640m) antes de seguir para Uyuni.',
      '🚌 Traslado La Paz → Uyuni incluso — ônibus leito noturno confortável (~10 a 12h de viagem). Saída por volta das 21h, chegada no início da manhã em Uyuni. Opção de voo direto disponível com adicional (consulte).',
      '',
      '─── DIA 1: DESCOBRINDO O SALAR DE UYUNI ───',
      '',
      '⏰ 10h30 — Saída de Uyuni em veículo 4x4. Encontro com o motorista-guia que acompanhará o grupo durante toda a expedição.',
      '🚂 Cemitério de Trens — Primeira parada da aventura. Antigas locomotivas a vapor abandonadas no deserto desde o auge da mineração boliviana no século XIX. Cenário perfeito para fotos impressionantes com as montanhas ao fundo.',
      '🏘️ Colchani — Visita ao povoado tradicional onde comunidades locais mantêm técnicas centenárias de extração e produção artesanal de sal. Conheça esculturas, artesanatos e produtos feitos com o mineral que deu fama mundial à região.',
      '🧂 Entrada no Salar de Uyuni — O momento mais esperado! Atravesse a imensa superfície branca formada por um antigo lago pré-histórico. O horizonte desaparece e o céu se funde com a terra. Hora de fazer as famosas fotos de perspectiva!',
      '💧 Ojos del Salar — Pequenas fontes naturais onde águas subterrâneas borbulham através da crosta de sal. Um fenômeno geológico fascinante que revela a atividade escondida abaixo do maior salar do planeta.',
      '🏨 Hotel de Sal Playa Blanca — Primeiro hotel construído inteiramente com blocos de sal extraídos do próprio Salar. Paredes, teto, mesas e até camas são feitas de sal cristalizado. Um ícone da região.',
      '🏁 Praça das Bandeiras & Monumento Dakar — A Praça das Bandeiras reúne bandeiras de viajantes de todo o mundo, representando a união entre culturas. Ao lado, o Monumento Dakar homenageia o famoso rally internacional que cruzou esta paisagem épica.',
      '🍽️ Almoço no Salar — Refeição incluída no meio do deserto de sal. Imagine almoçar cercado pelo branco infinito, com vista para as montanhas da Cordilheira dos Andes ao longe.',
      '🏝️ Ilha Incahuasi — Antiga ilha vulcânica no meio do Salar, famosa pelos cactos gigantes de até 12 metros de altura (alguns com mais de 1.200 anos!). Suba até o mirante para uma vista panorâmica de 360° do Salar.',
      '🌅 Pôr do Sol no Salar de Uyuni — Finalize o dia com um dos pores do sol mais espetaculares do mundo. Na temporada de chuvas (dezembro a março), a fina camada de água cria o famoso Efeito Espelho, refletindo perfeitamente o céu.',
      '🛏️ Hospedagem compartilhada em Uyuni ou arredores (incluída). Quartos simples, limpos e aconchegantes com banheiro e água quente. Opção de upgrade para quarto privativo: adicional de US$ 40/pessoa.',
      '',
      '─── DIA 2: LAGOAS COLORIDAS, DESERTOS E VULCÕES ───',
      '',
      '☀️ Após o café da manhã (incluído), partida para o segundo dia de expedição pelo Altiplano.',
      '🌋 Vulcão Ollagüe — Parada panorâmica para admirar este impressionante vulcão ativo de 5.868 metros, localizado na fronteira entre Bolívia e Chile. Sua silhueta imponente domina a paisagem com uma leve fumaça saindo do cume.',
      '💙 Laguna Cañapa — Bela lagoa de altitude cercada por montanhas, onde você já começa a avistar os primeiros flamingos andinos se alimentando nas águas ricas em minerais.',
      '🦩 Laguna Hedionda — Famosa pela grande concentração de flamingos andinos. Apesar do nome (que significa "fedorenta" em espanhol, pelo cheiro de enxofre), a paisagem é espetacular: flamingos rosados contra montanhas ocres.',
      '🏞️ Laguna Honda — Uma lagoa tranquila e menos visitada, perfeita para contemplar a imensidão do Altiplano em silêncio.',
      '🏜️ Deserto Siloli — Um dos desertos mais altos do mundo (acima de 4.500m). Paisagens esculpidas pelo vento durante milhares de anos criam formações surreais. Sensação de estar em Marte!',
      '🪨 Árbol de Piedra — A famosa "Árvore de Pedra", uma formação rochosa natural criada pela erosão do vento que desafia a gravidade. Um dos ícones mais fotografados da Bolívia. Parece uma árvore petrificada gigante no meio do deserto.',
      '❤️ Laguna Colorada — Uma das paisagens mais impressionantes da viagem. Suas águas vermelhas (causadas por algas e minerais) criam um contraste espetacular com os flamingos rosados, as montanhas ocres e o céu azul intenso. Difícil acreditar que é real.',
      '🛏️ Hospedagem compartilhada na região do Altiplano (incluída). Noite fria e estrelada — o céu do Altiplano é um dos mais limpos do mundo para observar constelações.',
      '',
      '─── DIA 3: GÊISERES, TERMAS E RETORNO ───',
      '',
      '🌄 Saída bem cedo (antes do amanhecer) para aproveitar o melhor horário nos gêiseres.',
      '💨 Gêiseres Sol de Mañana — Campo geotérmico a 4.850 metros de altitude. Jatos de vapor e lama borbulhante saem da terra enquanto o sol nasce atrás das montanhas. O chão treme e o ar cheira a enxofre — parece que você está em outro planeta.',
      '♨️ Termas de Polques — Hora de relaxar! Piscinas naturais de águas termais quentinhas (cerca de 30°C) no meio do Altiplano gelado. Tome banho enquanto admira as montanhas e vulcões ao redor. Revigorante!',
      '💚 Laguna Verde — Aos pés do majestoso Vulcão Licancabur (5.916m), esta lagoa tem águas verde-esmeralda devido aos minerais dissolvidos. A cor varia conforme a intensidade do vento e do sol. Cartão-postal clássico da Bolívia.',
      '🤍 Laguna Blanca — Última grande parada: uma lagoa de águas claras e calmas cercada por montanhas nevadas. Momento de contemplação e últimas fotos antes do retorno.',
      '🚙 Retorno a Uyuni — Após 3 dias de aventura, chegada em Uyuni no final da tarde. Fim da expedição. Nossa equipe pode ajudar a organizar seu retorno a La Paz (ônibus noturno ou voo no dia seguinte — não incluso).',
    ],
    included: [
      'Transporte em veículo 4x4 durante toda a expedição',
      'Motorista-guia experiente (espanhol)',
      'Grupo reduzido',
      'Combustível e despesas do veículo',
      'Alimentação durante o roteiro',
      'Café da manhã, almoço e jantar conforme programação',
      '2 noites de hospedagem compartilhada',
      'Todas as visitas do roteiro',
    ],
    notIncluded: [
      'Hospedagem privativa (adicional de US$ 40 por pessoa para as 2 noites — solicite na reserva)',
      'Voo La Paz → Uyuni (adicional opcional — consulte valores)',
      'Retorno Uyuni → La Paz após o término da expedição (ônibus ou voo)',
      'Bebidas alcoólicas e snacks extras',
      'Seguro viagem (recomendado — contrate antes de viajar)',
      'Despesas pessoais e compras em comunidades locais',
      'Gorjetas (opcionais, a critério do viajante)',
      'Entrada de atrações não mencionadas no programa',
    ],
    bringItems: [
      'Roupas quentes (temperaturas de até -10°C à noite)',
      'Gorro, luvas e cachecol',
      'Protetor solar (obrigatório)',
      'Óculos de sol (essencial no Salar)',
      'Calçados confortáveis tipo bota ou tênis de trilha',
      'Mochila pequena para pertences durante o dia',
      'Água (mínimo 1,5 litro por dia)',
      'Documentos pessoais',
      'Medicamentos pessoais',
      'Câmera com bateria extra (poucas tomadas nas hospedagens)',
    ],
    meetingPoint: 'O viajante deve chegar em La Paz, Bolívia. O traslado La Paz → Uyuni (ônibus leito noturno) está incluso. Em Uyuni, o ponto de encontro é nossa agência parceira — endereço exato enviado na confirmação da reserva.',
    startTime: 'Chegada em La Paz (dia anterior) — Saída da expedição: 10h30 (Dia 1 em Uyuni)',
    maxGroupSize: '6 pessoas por veículo',
    cancellation: 'Você tem direito ao arrependimento e poderá cancelar em até 7 dias após a compra com reembolso de 100%, desde que seja respeitado o prazo de 72 horas antes da data e horário de início da expedição.',
    privacyPolicy: 'O roteiro pode sofrer alterações devido às condições climáticas, segurança ou estado das estradas. Passageiros com problemas de saúde devem consultar um médico antes da viagem devido à altitude elevada (até 5.000m). Aplicam-se os termos e condições gerais disponíveis no site.',
    importantNotes: [
      '🛬 Turista deve chegar em La Paz, Bolívia — traslado noturno La Paz→Uyuni incluso no pacote',
      '✈️ Opção de voo La Paz→Uyuni disponível como adicional (consulte-nos para valores)',
      '🗓️ Recomendação: chegar em La Paz com 1 dia de antecedência para aclimatação à altitude',
      '🏔️ Altitude máxima: aproximadamente 5.000 metros — consulte seu médico antes da viagem',
      '🥶 Temperaturas noturnas: podem chegar a -15°C — leve roupas térmicas adequadas',
      '🛏️ Hospedagem padrão: compartilhada (incluída no pacote)',
      '🔑 Hospedagem privativa: adicional de US$ 40/pessoa para as 2 noites — solicite na reserva',
      '🚙 Grupos reduzidos de até 6 passageiros por veículo 4x4 Toyota Land Cruiser',
      '🌧️ Roteiro sujeito a alterações por condições climáticas severas ou estado das estradas',
      '🚌 Retorno Uyuni→La Paz não incluso — nossa equipe pode organizar se solicitado',
    ],
    gallery: [
      'https://readdy.ai/api/search-image?query=Stunning%20Salar%20de%20Uyuni%20salt%20flat%20at%20sunset%20with%20reflection%20mirror%20effect%20on%20water%20surface%2C%20endless%20white%20horizon%2C%20dramatic%20clouds%2C%20Bolivia%20altiplano%2C%20travel%20photography%2C%20breathtaking%20landscape%2C%20warm%20golden%20light%2C%20minimalist%20composition%20with%20salt%20hexagons%20texture%20in%20foreground&width=900&height=600&seq=salar-uyuni-hero&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Incahuasi%20Island%20in%20Salar%20de%20Uyuni%20covered%20with%20giant%20cacti%20against%20bright%20blue%20sky%2C%20white%20salt%20surrounding%2C%20Bolivia%20altiplano%2C%20travel%20photography%2C%20striking%20contrast%2C%20wide%20angle%20view&width=900&height=600&seq=salar-gallery-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Train%20cemetery%20in%20Uyuni%20Bolivia%20with%20rusty%20old%20steam%20locomotives%20abandoned%20in%20desert%2C%20clear%20blue%20sky%2C%20dramatic%20landscape%2C%20travel%20photography%2C%20artistic%20composition%2C%20warm%20desert%20tones&width=900&height=600&seq=salar-gallery-3&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Red%20Lagoon%20Laguna%20Colorada%20Bolivia%20with%20flamingos%20feeding%20in%20shallow%20red%20water%2C%20Andes%20mountains%20background%2C%20altiplano%20landscape%2C%20bright%20colors%2C%20travel%20photography%2C%20stunning%20natural%20scene&width=900&height=600&seq=salar-gallery-4&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Sol%20de%20Manana%20geysers%20at%20sunrise%20with%20steam%20venting%20from%20volcanic%20ground%2C%20altiplano%20Bolivia%2C%20dramatic%20lighting%2C%20otherworldly%20landscape%2C%20travel%20photography%2C%20atmospheric%20scene%20with%20golden%20rays&width=900&height=600&seq=salar-gallery-5&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Thermal%20hot%20springs%20Termas%20de%20Polques%20in%20Bolivia%20altiplano%20with%20steam%20rising%20from%20natural%20pool%2C%20Andes%20mountains%20panorama%2C%20crystal%20clear%20water%2C%20travel%20photography%2C%20serene%20atmosphere&width=900&height=600&seq=salar-gallery-6&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Green%20Lagoon%20Laguna%20Verde%20at%20foot%20of%20Licancabur%20volcano%20Bolivia%2C%20emerald%20green%20water%2C%20snow%20capped%20mountain%2C%20altiplano%2C%20stunning%20natural%20colors%2C%20travel%20photography&width=900&height=600&seq=salar-gallery-7&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Stone%20Tree%20Arbol%20de%20Piedra%20rock%20formation%20in%20Siloli%20Desert%20Bolivia%2C%20wind%20eroded%20sculpture%2C%20blue%20sky%2C%20high%20altitude%20desert%2C%20travel%20photography%2C%20dramatic%20landscape&width=900&height=600&seq=salar-gallery-8&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Andean%20flamingos%20wading%20in%20shallow%20lagoon%20water%20with%20mountains%20reflection%2C%20Bolivia%20altiplano%2C%20pink%20birds%2C%20travel%20wildlife%20photography%2C%20peaceful%20scene%2C%20clear%20blue%20sky&width=900&height=600&seq=salar-gallery-9&orientation=landscape',
      'https://readdy.ai/api/search-image?query=4x4%20vehicle%20crossing%20white%20salt%20flat%20Salar%20de%20Uyuni%2C%20endless%20white%20horizon%2C%20clear%20blue%20sky%2C%20adventure%20travel%2C%20freedom%20feeling%2C%20Bolivia%2C%20travel%20photography%2C%20minimalist%20composition&width=900&height=600&seq=salar-gallery-10&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Sunrise%20over%20Salar%20de%20Uyuni%20with%20hexagonal%20salt%20patterns%20glowing%20golden%2C%20dramatic%20sky%2C%20Bolivia%20altiplano%2C%20vast%20open%20landscape%2C%20travel%20photography%2C%20warm%20morning%20light&width=900&height=600&seq=salar-gallery-11&orientation=landscape',
      'https://storage.helloreaddy.io/project_files/7c7802d6-a309-4e70-ba60-a9d8c5ce7dd4/d0557439-9660-40c0-87db-967b3b8aa467_compressed_1000130669.webp',
      'https://readdy.ai/api/search-image?query=Salt%20hotel%20building%20made%20entirely%20of%20white%20salt%20blocks%20in%20Salar%20de%20Uyuni%20Bolivia%2C%20unique%20architecture%2C%20bright%20blue%20sky%2C%20salt%20desert%20background%2C%20travel%20destination%2C%20midday%20light%2C%20stunning%20travel%20photography%2C%20wide%20angle%20shot%20with%20salt%20bricks%20visible%20on%20walls%20and%20furniture&width=900&height=600&seq=salar-gallery-hotel-sal&orientation=landscape',
      'https://storage.helloreaddy.io/project_files/7c7802d6-a309-4e70-ba60-a9d8c5ce7dd4/f8245d45-86ae-481c-962f-c632c7fade5f_compressed_1000130666.webp',
      'https://readdy.ai/api/search-image?query=Flags%20from%20many%20countries%20and%20continents%20waving%20at%20Pra%C3%A7a%20das%20Bandeiras%20flag%20square%20in%20Salar%20de%20Uyuni%20Bolivia%2C%20colorful%20international%20flags%20against%20bright%20blue%20sky%2C%20white%20salt%20flat%20background%20stretching%20to%20horizon%2C%20travel%20photography%2C%20multicultural%20landmark%2C%20sunny%20day%2C%20vibrant%20colors%2C%20epic%20travel%20destination%20panorama&width=900&height=600&seq=salar-gallery-bandeiras&orientation=landscape',
    ],
    relatedTourIds: [],
    flashDeal: { originalPrice: 1500, dealPrice: 1200, postOfferPrice: 1200 },
  },
  {
    id: '20',
    slug: 'escuna-aquamarina-ii-privativa',
    title: 'Escuna Aquamarina II Privativa — Casamentos, Aniversários e Eventos',
    subtitle: 'A escuna inteira só para o seu grupo: 5 horas, dia inteiro ou com pernoite em alto-mar',
    description: 'A Escuna Aquamarina II inteira para o seu evento em Paraty: casamento, aniversário ou um encontro entre amigos. Cotação pelo WhatsApp para 5 horas, dia inteiro ou um dia e uma noite com amanhecer em alto-mar.',
    longDescription: `Um serviço privativo para eventos especiais: a Escuna Aquamarina II inteira, exclusiva para o seu grupo — casamentos, pedidos de casamento, aniversários, confraternizações e encontros entre amigos.

Você escolhe na cotação como quer viver o dia: 5 horas pelas praias e ilhas da Baía de Paraty; o dia inteiro, com mais paradas e mais tempo em cada uma; ou um dia e uma noite — jantar a bordo, noite ancorada em alto-mar e o nascer do sol sobre a baía no dia seguinte.

A embarcação é 100% nova, com o maior escorregador triplo do Cais de Paraty, Wi-Fi via Starlink, coração e balanço instagramáveis, bote de apoio para desembarque nas praias, banheiros masculino e feminino, som ambiente e bar e restaurante a bordo (pago à parte). O roteiro sugerido é o sul — Ilha dos Cocos, Praia da Lula, Lagoa Azul e Praia da Conceição — e pode ser adaptado ao seu evento.

A reserva é por cotação direta no WhatsApp: conte a data, quantas pessoas vão e o formato (5 horas, dia inteiro ou com pernoite) e respondemos com o valor da escuna completa.`,
    price: 4000,
    priceUnit: 'Escuna privada',
    duration: 'A combinar',
    difficulty: 'Fácil',
    tags: [
      'Privativo',
      'De barco',
      'Ideal para casais',
      'Ideal para famílias',
      'Pernoite',
    ],
    imageUrl: 'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/55e971c5-66d3-4481-cd46-77b181f81500/w=900',
    status: 'Privativo',
    imagesCount: 9,
    itinerary: [
      'Embarque no Cais de Turismo de Paraty, em horário combinado na cotação',
      'Roteiro sul sugerido: Ilha dos Cocos, Praia da Lula, Lagoa Azul e Praia da Conceição — adaptável ao seu evento',
      'Paradas para banho, snorkel e fotos, no ritmo do seu grupo',
      'Decoração, bolo, buffet ou música: combinamos tudo na cotação',
      '(Com pernoite) Jantar a bordo e noite ancorada em alto-mar',
      '(Com pernoite) Café da manhã com o nascer do sol sobre a baía',
      'Retorno ao Cais de Turismo no horário combinado',
    ],
    included: [
      'A Escuna Aquamarina II inteira, exclusiva para o seu grupo',
      'Paradas nas melhores praias e ilhas de Paraty',
      'Bote de apoio para desembarque nas praias',
      'Flutuadores (espaguetes) para nado livre',
      'Escorregador triplo – o maior do Cais de Paraty',
      'Wi-Fi Starlink a bordo',
      'Som ambiente',
      'Banheiros masculino e feminino',
      'Colete salva-vidas disponível para crianças',
    ],
    notIncluded: [
      'Bebidas e alimentos (adquiridos no bar/restaurante a bordo, pago à parte)',
      'Equipamentos de mergulho',
      'Transfer de hotel',
      'Decoração, buffet e atrações para o evento (organizamos sob consulta)',
    ],
    bringItems: [
      'Protetor solar (obrigatório)',
      'Roupa de banho',
      'Toalha',
      'Chapéu ou boné',
      'Óculos de sol',
      'Dinheiro para consumo no bar/restaurante a bordo',
      'Câmera ou celular em capa à prova d\'água',
    ],
    meetingPoint: 'Cais de Turismo de Paraty. Horário e detalhes do evento combinados na cotação pelo WhatsApp.',
    startTime: 'A combinar',
    maxGroupSize: 'Consultar capacidade para o seu evento',
    cancellation: 'Cancelamento com 7 dias ou mais de antecedência: reembolso integral. Entre 7 dias e 48 horas antes do passeio: poderá haver retenção de até 20% do valor. Com menos de 48 horas ou não comparecimento (no-show): não há reembolso. Se a empresa cancelar por segurança, condições climáticas ou motivos operacionais, você pode remarcar o passeio ou receber reembolso integral. Troca de data sem custo até 24 horas antes do passeio.',
    privacyPolicy: 'PROIBIDO EMBARQUE COM BEBIDAS OU ALIMENTOS. Somente serão autorizados mediante prévia coordenação com o responsável. A programação e o roteiro poderão sofrer alterações em razão das condições climáticas e marítimas, incluindo vento, condições do mar e outros fatores que possam comprometer a segurança da operação. Durante a travessia dos passageiros da embarcação até a praia, realizada por meio de bote de apoio, a empresa não se responsabiliza por pertences pessoais que sejam molhados, danificados, extraviados ou perdidos. A partir do momento em que os passageiros deixam a embarcação, a responsabilidade pela guarda e conservação de seus pertences pessoais passa a ser exclusivamente dos próprios clientes. Aplicam-se também os termos e condições gerais disponíveis no site.',
    importantNotes: [
      'Reserva somente por cotação no WhatsApp: informe a data, quantas pessoas vão e o formato (5 horas, dia inteiro ou com pernoite)',
      'O valor é pela escuna completa e varia conforme a duração e a data',
      'Pernoite em alto-mar sujeito às condições do tempo e do mar',
      'Data sujeita à disponibilidade da escuna',
    ],
    gallery: [
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/55e971c5-66d3-4481-cd46-77b181f81500/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/765c03fc-5c17-41a7-eaf9-a88d3ddffd00/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/f85998c3-7c0d-4f95-8d13-e53cc56a7100/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/c185b958-8d47-4924-f440-2c754a99e400/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/5ee380ea-536a-491f-0de8-3e4a45f1f800/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/d7eae037-7c3e-4d87-6ae3-2cdc3ddc9f00/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/05038d12-e9e5-40af-b58e-74029b904e00/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/4383832f-9a13-4933-3fce-c3f0d087a200/w=900',
      'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/86abfafc-8c41-48da-aff3-4871ee120a00/w=900',
    ],
    relatedTourIds: [
      'escuna-poseidon-privativa',
      'experiencia-privativa-em-paraty-a-bordo-de-uma-escuna-de-luxo',
      'lancha-privada-madame',
    ],
  },
  {
    id: '21',
    slug: 'escuna-poseidon-privativa',
    title: 'Escuna Poseidon Privativa — Casamentos, Aniversários e Eventos',
    subtitle: 'A escuna inteira só para o seu grupo: 5 horas, dia inteiro ou com pernoite em alto-mar',
    description: 'A Escuna Poseidon inteira para o seu evento em Paraty: casamento, aniversário ou um encontro entre amigos. Cotação pelo WhatsApp para 5 horas, dia inteiro ou um dia e uma noite com amanhecer em alto-mar.',
    longDescription: `Um serviço privativo para eventos especiais: a Escuna Poseidon inteira, exclusiva para o seu grupo — casamentos, pedidos de casamento, aniversários, confraternizações e encontros entre amigos.

Você escolhe na cotação como quer viver o dia: 5 horas pelas praias e ilhas de Paraty; o dia inteiro, com mais paradas e mais tempo em cada uma; ou um dia e uma noite — jantar a bordo, noite ancorada em alto-mar e o nascer do sol sobre a baía no dia seguinte.

A Poseidon é nova e moderna, com Wi-Fi via Starlink, escorregador triplo, áreas instagramáveis para fotos, bote de apoio para desembarque nas praias, som ambiente, banheiros e tripulação experiente. O roteiro sugerido é o norte — Ilha do Marbão, Ilha da Rapada, Praia Comprida do Norte e Praia do Rosa, o lado mais tranquilo e preservado de Paraty — e pode ser adaptado ao seu evento.

A reserva é por cotação direta no WhatsApp: conte a data, quantas pessoas vão e o formato (5 horas, dia inteiro ou com pernoite) e respondemos com o valor da escuna completa.`,
    price: 4000,
    priceUnit: 'Escuna privada',
    duration: 'A combinar',
    difficulty: 'Fácil',
    tags: [
      'Privativo',
      'De barco',
      'Ideal para casais',
      'Ideal para famílias',
      'Pernoite',
    ],
    imageUrl: 'https://storage.helloreaddy.io/project_files/7c7802d6-a309-4e70-ba60-a9d8c5ce7dd4/69e412a1-7234-4e74-b710-16446654cc6b_1000130639.jpg',
    status: 'Privativo',
    imagesCount: 10,
    itinerary: [
      'Embarque no Cais de Turismo de Paraty, em horário combinado na cotação',
      'Roteiro norte sugerido: Ilha do Marbão, Ilha da Rapada, Praia Comprida do Norte e Praia do Rosa — adaptável ao seu evento',
      'Paradas para banho, snorkel e fotos, no ritmo do seu grupo',
      'Decoração, bolo, buffet ou música: combinamos tudo na cotação',
      '(Com pernoite) Jantar a bordo e noite ancorada em alto-mar',
      '(Com pernoite) Café da manhã com o nascer do sol sobre a baía',
      'Retorno ao Cais de Turismo no horário combinado',
    ],
    included: [
      'A Escuna Poseidon inteira, exclusiva para o seu grupo',
      'Roteiro Norte exclusivo com 4 paradas em locais paradisíacos',
      'Wi-Fi via Starlink durante todo o passeio',
      'Escorregador triplo – diversão para adultos e crianças',
      'Bote de apoio para desembarque nas praias',
      'Áreas instagramáveis para fotos incríveis',
      'Paradas para mergulho e banho em águas cristalinas',
      'Tripulação experiente',
      'Som ambiente',
      'Banheiros a bordo',
      'Colete salva-vidas disponível',
    ],
    notIncluded: [
      'Bebidas e alimentos (adquiridos no bar/restaurante a bordo, pago à parte)',
      'Equipamentos de mergulho',
      'Transfer de hotel',
      'Decoração, buffet e atrações para o evento (organizamos sob consulta)',
    ],
    bringItems: [
      'Roupa de banho',
      'Toalha',
      'Protetor solar (obrigatório)',
      'Chapéu ou boné',
      'Óculos de sol',
      'Dinheiro ou cartão para consumo a bordo',
      'Câmera ou celular para fotos',
    ],
    meetingPoint: 'Cais de Turismo de Paraty. Horário e detalhes do evento combinados na cotação pelo WhatsApp.',
    startTime: 'A combinar',
    maxGroupSize: 'Consultar capacidade para o seu evento',
    cancellation: 'Você tem direito ao arrependimento e poderá cancelar em até 7 dias após a compra com reembolso de 100%, desde que seja respeitado o prazo de 24 horas antes da data e horário do agendamento. Troca de data sem custo algum.',
    privacyPolicy: 'PROIBIDO EMBARQUE COM BEBIDAS OU ALIMENTOS. Somente serão autorizados mediante prévia coordenação com o responsável. Aplicam-se também os termos e condições gerais disponíveis no site.',
    importantNotes: [
      'Reserva somente por cotação no WhatsApp: informe a data, quantas pessoas vão e o formato (5 horas, dia inteiro ou com pernoite)',
      'O valor é pela escuna completa e varia conforme a duração e a data',
      'Pernoite em alto-mar sujeito às condições do tempo e do mar',
      'Data sujeita à disponibilidade da escuna',
    ],
    gallery: [
      'https://storage.helloreaddy.io/project_files/7c7802d6-a309-4e70-ba60-a9d8c5ce7dd4/69e412a1-7234-4e74-b710-16446654cc6b_1000130639.jpg',
      'https://readdy.ai/api/search-image?query=A%20modern%20white%20schooner%20boat%20sailing%20on%20crystal%20clear%20turquoise%20waters%20near%20tropical%20green%20islands%20in%20Paraty%20Brazil%2C%20bright%20sunny%20day%2C%20professional%20travel%20photography%2C%20vibrant%20colors&width=900&height=600&seq=poseidon-gallery-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Tropical%20beach%20with%20calm%20crystal%20clear%20water%20and%20white%20sand%20surrounded%20by%20lush%20Atlantic%20Forest%20mountains%20in%20Paraty%20Brazil%2C%20paradise%20landscape%2C%20no%20people%2C%20bright%20sunlight&width=900&height=600&seq=poseidon-gallery-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=People%20swimming%20and%20snorkeling%20in%20transparent%20turquoise%20water%20near%20a%20white%20boat%20at%20a%20tropical%20island%20in%20Brazil%2C%20happy%20vacation%20atmosphere%2C%20sunny%20day%2C%20travel%20lifestyle%20photography&width=900&height=600&seq=poseidon-gallery-3&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Drone%20aerial%20view%20of%20a%20beautiful%20tropical%20bay%20with%20emerald%20green%20water%20and%20small%20islands%20in%20Paraty%20Brazil%2C%20stunning%20coastal%20landscape%2C%20atlantic%20forest%20covering%20the%20mountains&width=900&height=600&seq=poseidon-gallery-4&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Tourists%20enjoying%20a%20boat%20trip%20with%20water%20slide%20on%20a%20schooner%20in%20tropical%20waters%20Brazil%2C%20fun%20summer%20vacation%2C%20bright%20colors%2C%20joyful%20atmosphere%2C%20travel%20photography&width=900&height=600&seq=poseidon-gallery-5&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Secluded%20tropical%20beach%20with%20pink%20sand%20and%20calm%20blue%20water%20surrounded%20by%20green%20hills%20in%20Brazil%2C%20paradise%20setting%2C%20no%20people%2C%20pristine%20nature%2C%20travel%20destination&width=900&height=600&seq=poseidon-gallery-6&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Historic%20colonial%20pier%20in%20Paraty%20Brazil%20with%20colorful%20boats%20docked%2C%20cobblestone%20streets%20and%20white%20buildings%20in%20background%2C%20warm%20afternoon%20light%2C%20travel%20photography&width=900&height=600&seq=poseidon-gallery-7&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Group%20of%20friends%20taking%20photos%20on%20a%20beautiful%20boat%20deck%20with%20tropical%20island%20background%20Brazil%2C%20instagram%20worthy%20spot%2C%20happy%20vibes%2C%20summer%20travel%20lifestyle&width=900&height=600&seq=poseidon-gallery-8&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Sunset%20view%20from%20a%20boat%20deck%20over%20the%20bay%20of%20Paraty%20with%20mountains%20silhouette%2C%20golden%20hour%20light%2C%20peaceful%20atmosphere%2C%20romantic%20travel%20scene&width=900&height=600&seq=poseidon-gallery-9&orientation=landscape',
    ],
    relatedTourIds: [
      'escuna-aquamarina-ii-privativa',
      'experiencia-privativa-em-paraty-a-bordo-de-uma-escuna-de-luxo',
      'lancha-privada-madame',
    ],
  },
];
